import { createI18n } from "vue-i18n/index";
import { registerI7aI18n, withI7aMessages } from "@/i18n/i7a";
import { registerI7bI18n } from "@/i18n/i7b";
import { registerPromotionsI18n } from "@/i18n/promotions";
import { registerMessageTemplatesI18n } from "@/i18n/messageTemplates";

const messages = {
  en: {
    dashboard: "Dashboard",
    layoutBuilder: "Layout builder",
    craft: "Crafted",
    pages: "Pages",
    profile: "Profile",
    profileOverview: "Overview",
    projects: "Projects",
    campaigns: "Campaigns",
    documents: "Documents",
    connections: "Connections",
    wizards: "Wizards",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Account",
    accountOverview: "Overview",
    settings: "Settings",
    authentication: "Authentication",
    basicFlow: "Basic Flow",
    signIn: "Sign-in",
    signUp: "Sign-up",
    passwordReset: "Password Reset",
    multiStepSignUp: "Multi-steps Sign up",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Apps",
    chat: "Chat",
    widgets: "Widgets",
    widgetsLists: "Lists",
    widgetsStatistics: "Statistics",
    widgetsCharts: "Charts",
    widgetsMixed: "Mixed",
    widgetsTables: "Tables",
    widgetsFeeds: "Feeds",
    changelog: "Changelog",
    docsAndComponents: "Docs & Components",
    megaMenu: "Mega Menu",
    exampleLink: "Example link",
    modals: "Modals",
    general: "General",
    inviteFriends: "Invite Friends",
    viewUsers: "View Users",
    upgradePlan: "Upgrade Plan",
    shareAndEarn: "Share & Earn",
    forms: "Forms",
    newTarget: "New Target",
    newCard: "New Card",
    newAddress: "New Address",
    createAPIKey: "Create API Key",
    twoFactorAuth: "Two Factor Auth",
    createApp: "Create App",
    createAccount: "Create Account",
    documentation: "Documentation",
    components: "Components",
    resources: "Resources",
    activity: "Activity",
    customers: "Customers",
    gettingStarted: "Getting Started",
    customersListing: "Customers Listing",
    customerDetails: "Customers Details",
    calendarApp: "Calendar",
    subscriptions: "Subscriptions",
    getStarted: "Getting Started",
    subscriptionList: "Subscription List",
    addSubscription: "Add Subscription",
    viewSubscription: "View Subscription",
    connectionRouteInfoTitle: "Route Information",
    connectionRouteInfoRouteAndPricesTab: "Route & Prices",
    connectionRouteInfoRouteTab: "Route & Addresses",
    connectionRouteInfoLocality: "Locality",
    connectionRouteInfoAddress: "Address",
    connectionRouteInfoToAddress: "To Address",
    connectionRouteInfoTransfer: "Transfer",
    connectionRouteInfoPriceCategoriesTab: "Price Categories",
    connectionRouteInfoPriceCategory: "Price Category",
    connectionRouteInfoPricesTab: "Prices",
    connectionRouteInfoPrice: "Price",
    connectionRouteInfoArrival: "Arrival Locality",
    connectionRouteInfoTotal: "Total",
    connectionRouteInfoFareBreakdown: "Price breakdown",
    connectionRouteInfoFareHint: "Pick a boarding point and a drop-off point to see the exact fare for that journey.",
    connectionRouteInfoSelectPrompt: "Select a departure and an arrival to see the price.",
    connectionRouteInfoConvertedNote: "Segments normalized and converted to the connection currency.",
    connectionRouteInfoDeparture: "Departure Locality",
    connectionRouteInfoSegment: "Segment",
    connectionRouteInfoUnavailable: "Data unavailable",
    connectionRouteInfoNoRoute: "Data unavailable — segments have no associated routes.",
    connectionRouteInfoNoPriceData: "Data unavailable — no route points or price categories.",
    connectionRouteInfoTbd: "TBD",
    connectionRouteInfoYes: "Yes",
    connectionRouteInfoRouteLoadError: "Error loading route data. Please try again later.",
    connectionRouteInfoPricesLoadError: "Error loading prices. Please try again later.",
    connectionRouteInfoAvailableIn: "Available In",
    connectionRouteInfoSegmentLoadError: "Error loading data for this segment.",
    connectionRouteInfoTransferIndicator: "Transfer",
    connectionRouteInfoScheduleLabel: "Schedule",
    connectionRouteInfoDay1: "Mon",
    connectionRouteInfoDay2: "Tue",
    connectionRouteInfoDay3: "Wed",
    connectionRouteInfoDay4: "Thu",
    connectionRouteInfoDay5: "Fri",
    connectionRouteInfoDay6: "Sat",
    connectionRouteInfoDay7: "Sun",
    connectionFinalPrice: "Connection Final Price",
    connectionAuthoritativeTotal: "Configured Destination Total",
    connectionTransferMode: "Transfer Mode",
    connectionTransferModeOrganized: "Organized",
    connectionTransferModeUnorganized: "Unorganized",
    connectionTransferInstructions: "Transfer Instructions",
    connectionTransferInstructionsRo: "Romanian (RO)",
    connectionTransferInstructionsRu: "Russian (RU)",
    connectionTransferInstructionsEn: "English (EN)",
    connectionTransferInstructionsUk: "Ukrainian (UK)",
    connectionDepartureOverride: "Departure Transfer Instructions Override",
    connectionDepartureOverrideLoad: "Load Override",
    connectionDepartureOverrideSave: "Save Override",
    connectionDepartureOverrideWarning: "Changes affect ALL bookings on this departure, not just the current one.",
    connectionDepartureOverrideActive: "Override active — departure-specific instructions will be used",
    connectionDepartureOverrideNone: "No override — using connection defaults",
    connectionTransferInstructionsPlaceholderRo: "Transfer instructions (RO)",
    connectionTransferInstructionsPlaceholderRu: "Transfer instructions (RU)",
    connectionTransferInstructionsPlaceholderEn: "Transfer instructions (EN)",
    connectionTransferInstructionsPlaceholderUk: "Transfer instructions (UK)",
    connectionCreateTitle: "Create connection",
    connectionEditTitle: "Connection",
    connectionEditTitleWithId: "Connection #{id}",
    connectionEditTitleWithIdAndRoute: "Connection #{id} — {route}",
    connectionSave: "Save",
    connectionImportBsBs: "Import BS+BS",
    connectionCreate: "Create",
    connectionType: "Connection type",
    connectionTypeLocalLocal: "Local + Local",
    connectionTypeBsBsImport: "BS + BS (import)",
    connectionTypeBsBsBadge: "BS + BS (imported)",
    connectionTypeLocalLocalBadge: "Local + Local",
    connectionSegment1: "Segment 1",
    connectionSegment2: "Segment 2",
    connectionSegmentDepartureToTransfer: "Departure → Transfer point",
    connectionSegmentTransferToDestination: "Transfer point → Destination",
    connectionTransfer: "Transfer",
    connectionImportedSegments: "Imported segments",
    connectionImportedReadonly: "Imported connection — structural fields are read-only",
    connectionSegmentsReadonly: "Segments (read-only)",
    connectionPosition: "Position",
    connectionSegment1Helper: "Segment 1 defines the departure anchor up to the transfer city. The backend automatically extends all eligible combinations.",
    connectionSegment2Helper: "Segment 2 defines the anchor from the transfer city to the destination. Final combinations are automatically generated by the backend.",
    connectionSegment1HelperEdit: "Segment 1 anchor: departure point to transfer.",
    connectionSegment2HelperEdit: "Segment 2 anchor: transfer to destination.",
    connectionAnchorsAlert: "The selected segments are anchors. The backend automatically extends eligible combinations between the two segments.",
    connectionBsBsImportInfo: "BS+BS import uses the dedicated endpoint /connections/import-bs.",
    connectionSettings: "Connection settings",
    connectionStatus: "Status",
    connectionStatusDraft: "Draft",
    connectionStatusActive: "Active",
    connectionStatusInactive: "Inactive",
    connectionStatusPartial: "Partially active",
    connectionManualStatus: "Manual status",
    connectionManualStatusHelper: "This switch controls the operator's intent. Platform publication is shown separately.",
    connectionPublicationStatus: "Platform publication",
    connectionPublicationPublished: "Published",
    connectionPublicationPendingRebuild: "Rebuild pending",
    connectionPublicationBlocked: "Blocked",
    connectionPublicationRebuildFailed: "Rebuild failed",
    connectionPublicationUnpublished: "Unpublished",
    connectionPublicationPartial: "Partially published",
    connectionRebuildStatus: "Latest rebuild",
    connectionRebuildSucceeded: "Succeeded",
    connectionRebuildUnpublished: "No published result",
    connectionRebuildPartial: "Mixed rebuild results",
    connectionPublishedGenerationAt: "Published generation: {date}",
    connectionRebuildCheckedAt: "Rebuild checked: {date}",
    connectionPublicationReason: "Reason: {reason}",
    connectionPublicationCheckedAt: "Checked: {date}",
    connectionPublicationWarningTitle: "Publication status: {status}",
    connectionRebuildWarningTitle: "Latest rebuild: {status}",
    connectionPublicationPartialDescription: "Some schedules are not currently displayed on the platforms. Check each schedule below.",
    connectionPublicationUnpublishedDescription: "No schedule in this connection is currently displayed on the platforms.",
    connectionPublicationBlockedDescription: "The connection cannot currently be displayed on the platforms. Correct the route issue shown below.",
    connectionPublicationRebuildFailedDescription: "The last publication rebuild failed. The operator's manual status was not changed.",
    connectionRebuildFailedLiveDescription: "The latest rebuild failed, but the previous published generation remains displayed on the platforms.",
    connectionRebuildFailedNoLiveDescription: "The latest rebuild failed and there is currently no offer displayed on the platforms.",
    connectionRebuildFailedPartialLiveDescription: "The latest rebuild has failures. Only the schedules marked as published remain displayed.",
    connectionRebuildFailedUnknownLiveDescription: "The latest rebuild failed. This legacy response does not confirm whether an older generation remains displayed.",
    connectionPublicationReasonManualInactive: "The manual status is inactive.",
    connectionPublicationReasonParentRouteMissing: "A parent route no longer exists.",
    connectionPublicationReasonParentRouteInactive: "A parent route is inactive.",
    connectionPublicationReasonAnchorStopMissing: "A connection stop no longer exists.",
    connectionPublicationReasonAnchorStopRouteMismatch: "A connection stop no longer belongs to the selected route.",
    connectionPublicationReasonAnchorStopOrderInvalid: "The connection stops are no longer in a valid order.",
    connectionPublicationReasonScheduleMissing: "A selected schedule no longer exists.",
    connectionPublicationReasonAnchorTimeMissing: "Arrival or departure time is missing at a connection stop.",
    connectionPublicationReasonTransferContinuity: "The two segments no longer meet at the same transfer point.",
    connectionPublicationReasonTransferTimeSource: "Transfer time cannot be calculated from the current schedule.",
    connectionPublicationReasonNoSegment1Pairs: "Segment 1 has no sellable route pairs.",
    connectionPublicationReasonNoSegment2Pairs: "Segment 2 has no sellable route pairs.",
    connectionPublicationReasonNoCombinations: "The selected schedules have no sellable connection combinations.",
    connectionPublicationReasonTemporaryFailure: "A temporary error prevented the publication check. It will be retried.",
    connectionPublicationReasonBuildFailure: "The platform publication rebuild failed.",
    connectionPublicationReasonInvalidSegments: "The connection segment structure is invalid.",
    connectionTransferTimeMinutes: "Transfer time (minutes)",
    connectionFeePerPassenger: "Fee per passenger",
    connectionFeeCurrency: "Fee currency",
    connectionFeeCurrencyPlaceholder: "Currency",
    connectionCurrency: "Connection currency",
    connectionCurrencyPlaceholder: "Currency",
    connectionCurrencyHelper: "Total currency for this connection — separate from the fee currency.",
    connectionRefundPolicyLabel: "Refund policy",
    connectionRefundPolicyPlaceholder: "Select a refund policy",
    connectionRefundPolicyHelper: "Cancellation refunds use the selected policy when the connection is sold.",
    connectionRefundPolicyDisabledBs: "Refund policies cannot be attached to imported (BusSystem) connections.",
    connectionRefundPolicySaved: "Refund policy updated.",
    connectionRefundPolicySaveError: "Could not save the refund policy.",
    connectionFrom: "From",
    connectionTo: "To",
    connectionCompanyNum: "Company {num}",
    connectionRoute: "Route",
    connectionOpenRoute: "Open route",
    connectionTime: "Time",
    connectionSchedulePairsTitle: "Schedule pairs",
    connectionSchedulePairsHelper: "Choose the exact schedule on each segment. The first pair is the anchor used for the route preview.",
    connectionSchedulePairsSegment1: "Segment 1 schedule",
    connectionSchedulePairsSegment2: "Segment 2 schedule",
    connectionSchedulePairsAdd: "Add pair",
    connectionSchedulePairsRemove: "Remove pair",
    connectionSchedulePairsRemoveExistingConfirm: "This saved schedule will be removed when you save. The operation may be blocked if it has bookings or other dependencies. Continue?",
    connectionSchedulePairStatus: "Status",
    connectionSchedulePairStatusNew: "New",
    connectionConfirm: "Confirm",
    connectionCancel: "Cancel",
    connectionSchedulePairsGenerateWeek: "Generate week",
    connectionSchedulePairsAutoUnavailable: "Safe generation requires effective arrival/departure times at the transfer point and a maximum wait limit. Select each pair explicitly.",
    connectionSchedulePairsEmpty: "Add at least one schedule pair.",
    connectionSchedulePairsRequired: "At least one schedule pair is required.",
    connectionSchedulePairsIncomplete: "Complete both schedules on every row.",
    connectionSchedulePairsDuplicate: "This schedule pair already exists.",
    connectionSchedulePairsGenerated: "Generated {count} unambiguous schedule pairs.",
    connectionSchedulePairsGeneratedWithAmbiguous: "Generated {count} pairs. {ambiguous} day/parity groups have multiple schedules and require an explicit choice.",
    connectionScheduleEveryWeek: "every week",
    connectionScheduleOddWeeks: "odd weeks",
    connectionScheduleEvenWeeks: "even weeks",
    connectionFamilyScheduleCount: "{count} schedules",
    connectionTransferStation: "Transfer station",
    connectionFromStation: "From",
    connectionToStation: "To",
    connectionSaved: "Connection saved",
    connectionCreated: "Connection created",
    connectionBsBsImported: "BS+BS connection imported",
    connectionStatusUpdated: "Status updated",
    connectionFamilyActivationSuccess: "All {total} schedules were activated.",
    connectionFamilyActivationNone: "No schedules could be activated (0/{total}). Check the invalid schedules.",
    connectionFamilyActivationPartial: "{activated} of {total} schedules were activated. The family remains partially active.",
    connectionFamilyDeactivationSuccess: "All {total} schedules were deactivated.",
    connectionFamilyDeactivationIncomplete: "Not all schedules were deactivated ({deactivated}/{total}). Refresh and try again.",
    connectionSaveError: "Error saving",
    connectionRoutesLoadError: "Error loading routes",
    connectionScheduleLoadError: "Error loading schedule",
    connectionStationsLoadError: "Error loading stations",
    connectionSegment1ValidPairs: "Segment 1 valid pairs:",
    connectionSegment2ValidPairs: "Segment 2 valid pairs:",
    connectionTotalCombinations: "Total combinations:",
    connectionNoCombinationsEdit: "No sellable combinations for the current configuration.",
    connectionNoCombinationsCreate: "No sellable combinations for the selected anchors.",
    connectionFewCombinationsEdit: "Low number of generated combinations. Check anchor segments.",
    connectionFewCombinationsCreate: "Low number of generated combinations. Check prices and stops.",
    connectionCombinationsUpdated: "Combinations have been updated successfully.",
    connectionCombinationsGenerated: "Combinations have been generated successfully.",
    connectionErrorSessionExpired: "Session expired. Please log in again.",
    connectionErrorNoPermission: "You do not have permission for this action.",
    connectionErrorNotFound: "Resource not found or module unavailable.",
    connectionErrorNoSegment1Pairs: "Segment 1 has no valid pairs with a general price. Adjust the departure anchor or route.",
    connectionErrorNoSegment2Pairs: "Segment 2 has no valid pairs with a general price. Adjust the transfer anchor or destination.",
    connectionErrorNoCombinations: "No sellable combinations between the two anchors. Check prices and stops.",
    connectionErrorInvalidTransferStop: "The selected transfer stop is not valid for the segment route.",
    connectionErrorInvalidTransferTimeSource: "Cannot calculate transfer time — schedule data is missing or incomplete.",
    connectionErrorTransferContinuity: "The transfer city must be the same between both segments.",
    connectionErrorFamilyMemberInUse: "This schedule cannot be removed or replaced because it has bookings or other dependencies.",
    connectionErrorUnexpected: "Unexpected error. Please try again.",
    connectionBusIdLabel: "Bus",
    connectionRouteStatusLabel: "Route Status",
    connectionRouteActive: "Active",
    connectionRouteInactive: "Inactive",
    connectionConnOnlyLabel: "Conn. Only",
    connectionConnOnlyYes: "Conn. only",
    connectionTimeIdLabel: "Time ID",
    connectionFromIdLabel: "From",
    connectionToIdLabel: "To",
    connectionTabSegments: "Segments",
    connectionTabSettings: "Settings",
    connectionTabRouteInfo: "Route Info",
    connectionPlatformsTab: "Platforms",
    connectionPlatformsHelper: "Choose which commercial platforms this connection is sold on. Leaving the selection empty hides this connection from every platform.",
    connectionPlatformsSaved: "Connection platforms saved.",
    connectionPlatformsSaveError: "Could not save connection platforms.",
    connectionDiscard: "Discard changes",
    connectionPaymentMethodsTab: "Payment Methods",
    connectionPaymentMethodSaveError: "Error saving payment method",
    connectionPlatformPaymentIndependentHint: "Connection payment methods are configured per commercial platform and are independent from the segment routes.",
    connectionDiagTab: "Conexiune",
    connectionDiagMaster: "Rezervare Principala",
    connectionDiagSegments: "Segmente",
    connectionDiagSegmentPosition: "Segment",
    connectionDiagRoute: "Ruta",
    connectionDiagDeparture: "Plecare",
    connectionDiagCarrier: "Transportator",
    connectionDiagMismatchWarning: "Statusurile segmentelor nu corespund cu statusul rezervarii principale",
    connectionDiagStatusLabel: "Status Conexiune",
    connectionDiagCurrentBooking: "actual",
    connectionDiagArrival: "Sosire",
    connectionHandoffTitle: "Detalii transfer",
    connectionDropoff: "Coborâre Segment 1",
    connectionPickup: "Îmbarcare Segment 2",
    connectionWaitingTime: "Timp de așteptare",
    connectionTransferTime: "Timp de conexiune",
    platformPaymentTableTitle: "Payment methods per platform",
    platformPaymentTableDescription: "Configure how passengers pay on each commercial platform.",
    platformPaymentColumnPlatform: "Platform",
    platformPaymentColumnCash: "Cash",
    platformPaymentCashAddAll: "Add all",
    platformPaymentApplyToAll: "Apply to all platforms",
    platformPaymentColumnOnline: "Online payment",
    platformPaymentColumnStatus: "Status",
    platformPaymentStatusActive: "Active",
    platformPaymentStatusLocked: "Not visible · locked",
    platformPaymentStatusInvalid: "Invalid",
    platformPaymentEmpty: "No commercial platforms attached. Add platforms in the Platforms tab to configure payments.",
    platformPaymentDiscard: "Discard",
    platformPaymentSave: "Save changes",
    platformPaymentSaveSuccess: "Payment configuration saved",
    platformPaymentSaveError: "Error saving payment configuration",
    platformPaymentSaveValidation: "Please review the highlighted rows",
    platformPaymentErrorVisibleMissingMethod: "Choose Cash or an Online method.",
    platformPaymentErrorGeneric: "Invalid configuration.",
    platformPaymentOnlineNone: "None",
    platformPaymentOnlineMaib: "MAIB",
    platformPaymentOnlineNetopia: "Netopia",
    platformPaymentOnlineNetopiaConfigOnly: "Netopia (configuration only)",
    platformPaymentOnlineCarrierManaged: "Carrier-managed online",
    platformPaymentUnknownPlatform: "Unknown platform",
    platformPaymentReason_visible_platform_missing_method: "Choose Cash or an Online method.",
    platformPaymentReason_visible_platform_missing_assignment: "Assignment missing for this visible platform.",
    platformPaymentReason_duplicate_platform_assignment: "Duplicate platform assignment.",
    platformPaymentReason_unknown_hosted_method: "Online method not supported.",
    platformPaymentReason_method_not_hosted_family: "Online method must be hosted.",
    platformPaymentReason_hosted_method_not_in_registry: "Online method is not registered.",
    platformPaymentReason_registry_method_not_hosted: "Online method family mismatch.",
    platformPaymentReason_bus_system_not_hosted: "BusSystem cannot be used as hosted online method.",
    platformPaymentReason_cash_not_hosted_method: "Cash cannot be used as online method.",
    platformPaymentReason_inactive_non_visible: "Platform is no longer visible.",
    platformPaymentReason_platform_required: "Platform is required.",
    platformPaymentManagedByBusSystem: "Managed by BusSystem",
    platformPaymentCashOn: "On",
    platformPaymentCashOff: "Off",
  },
  es: {
    dashboard: "Tablero",
    layoutBuilder: "Constructor de maquetación",
    craft: "Elaborado",
    pages: "Paginas",
    profile: "Perfil",
    profileOverview: "Descripción general",
    projects: "Proyectos",
    campaigns: "Campañas",
    documents: "Documentos",
    connections: "Conexiones",
    wizards: "Magos",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Cuenta",
    accountOverview: "Descripción general",
    settings: "Ajustes",
    authentication: "Autenticación",
    basicFlow: "Flujo básico",
    signIn: "Registrarse",
    signUp: "Inscribirse",
    passwordReset: "Restablecimiento de contraseña",
    multiStepSignUp: "Regístrese Multi-Pasos",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Aplicaciones",
    chat: "Chat",
    widgets: "Widgets",
    widgetsLists: "Liza",
    widgetsStatistics: "Estadísticas",
    widgetsCharts: "Gráficos",
    widgetsMixed: "Mezclada",
    widgetsTables: "Mesas",
    widgetsFeeds: "Alimenta",
    changelog: "Registro de cambios",
    docsAndComponents: "Documentos & Componentes",
    megaMenu: "Mega menú",
    exampleLink: "Enlace de ejemplo",
    modals: "Modales",
    general: "General",
    inviteFriends: "Invitar A Amigos",
    viewUsers: "Ver Usuarios",
    upgradePlan: "Plan De Actualización",
    shareAndEarn: "Compartir Y Ganar",
    forms: "Formas",
    newTarget: "Nuevo Objetivo",
    newCard: "Nueva Tarjeta",
    newAddress: "Nueva Direccion",
    createAPIKey: "Crea Clave De Api",
    twoFactorAuth: "Dos Factores",
    createApp: "Crear Aplicacion",
    createAccount: "Crear Una Cuenta",
    activity: "Actividad",
    documentation: "Documentación",
    components: "Componentes",
    resources: "Recursos",
    customers: "Clientes",
    gettingStarted: "Empezando",
    customersListing: "Listado De Clientes",
    customerDetails: "Detalles De Los Clientes",
    calendarApp: "Calendario",
    subscriptions: "Suscripciones",
    getStarted: "Empezando",
    subscriptionList: "Lista De Suscripción",
    addSubscription: "Añadir Suscripción",
    viewSubscription: "Suscripción",
    connectionRouteInfoTitle: "Informatii ruta",
    connectionRouteInfoRouteAndPricesTab: "Traseu & Prețuri",
    connectionRouteInfoRouteTab: "Traseu & Adrese",
    connectionRouteInfoLocality: "Localitate",
    connectionRouteInfoAddress: "Adresa",
    connectionRouteInfoToAddress: "La adresa",
    connectionRouteInfoTransfer: "Transfer",
    connectionRouteInfoPriceCategoriesTab: "Categorii de preturi",
    connectionRouteInfoPriceCategory: "Categorie de pret",
    connectionRouteInfoPricesTab: "Prețuri",
    connectionRouteInfoPrice: "Pret",
    connectionRouteInfoArrival: "Localitatea de sosire",
    connectionRouteInfoTotal: "Total",
    connectionRouteInfoFareBreakdown: "Defalcare preț",
    connectionRouteInfoFareHint: "Alege punctul de îmbarcare și cel de coborâre pentru a vedea tariful exact al acelei călătorii.",
    connectionRouteInfoSelectPrompt: "Selectează plecarea și sosirea pentru a vedea prețul.",
    connectionRouteInfoConvertedNote: "Segmentele sunt normalizate și convertite în moneda conexiunii.",
    connectionRouteInfoDeparture: "Localitatea de plecare",
    connectionRouteInfoSegment: "Segment",
    connectionRouteInfoUnavailable: "Date indisponibile",
    connectionRouteInfoNoRoute: "Date indisponibile — segmentele nu au rute asociate.",
    connectionRouteInfoNoPriceData: "Date indisponibile — nu exista puncte de traseu sau categorii de pret.",
    connectionRouteInfoTbd: "TBD",
    connectionRouteInfoYes: "Da",
    connectionRouteInfoRouteLoadError: "Eroare la incarcarea datelor de ruta. Reincercati mai tarziu.",
    connectionRouteInfoPricesLoadError: "Eroare la incarcarea preturilor. Reincercati mai tarziu.",
    connectionRouteInfoAvailableIn: "Disponibil in",
    connectionRouteInfoSegmentLoadError: "Eroare la incarcarea datelor pentru acest segment.",
    connectionRouteInfoTransferIndicator: "Transfer",
    connectionRouteInfoDay1: "Lun",
    connectionRouteInfoDay2: "Mar",
    connectionRouteInfoDay3: "Mie",
    connectionRouteInfoDay4: "Joi",
    connectionRouteInfoDay5: "Vin",
    connectionRouteInfoDay6: "Sam",
    connectionRouteInfoDay7: "Dum",
    connectionFinalPrice: "Pret final conexiune",
    connectionAuthoritativeTotal: "Total destinatie configurata",
    connectionTransferMode: "Mod transfer",
    connectionTransferModeOrganized: "Organizat",
    connectionTransferModeUnorganized: "Neorganizat",
    connectionTransferInstructions: "Instructiuni de transfer",
    connectionTransferInstructionsRo: "Romana (RO)",
    connectionTransferInstructionsRu: "Rusa (RU)",
    connectionTransferInstructionsEn: "Engleza (EN)",
    connectionTransferInstructionsUk: "Ucraineana (UK)",
    connectionDepartureOverride: "Suprascriere instructiuni transfer plecare",
    connectionDepartureOverrideLoad: "Incarca suprascriere",
    connectionDepartureOverrideSave: "Salveaza suprascriere",
    connectionDepartureOverrideWarning: "Modificarile afecteaza TOATE rezervarile din aceasta plecare, nu doar cea curenta.",
    connectionDepartureOverrideActive: "Suprascriere activa — se vor folosi instructiunile specifice plecarii",
    connectionDepartureOverrideNone: "Fara suprascriere — se folosesc valorile implicite ale conexiunii",
    connectionTransferInstructionsPlaceholderRo: "Instructiuni transfer (RO)",
    connectionTransferInstructionsPlaceholderRu: "Instructiuni transfer (RU)",
    connectionTransferInstructionsPlaceholderEn: "Instructiuni transfer (EN)",
    connectionTransferInstructionsPlaceholderUk: "Instructiuni transfer (UK)",
    connectionCreateTitle: "Creaza conexiune",
    connectionEditTitle: "Conexiune",
    connectionEditTitleWithId: "Conexiune #{id}",
    connectionEditTitleWithIdAndRoute: "Conexiune #{id} — {route}",
    connectionSave: "Salveaza",
    connectionImportBsBs: "Importa BS+BS",
    connectionCreate: "Creaza",
    connectionType: "Tip conexiune",
    connectionTypeLocalLocal: "Local + Local",
    connectionTypeBsBsImport: "BS + BS (import)",
    connectionTypeBsBsBadge: "BS + BS (importat)",
    connectionTypeLocalLocalBadge: "Local + Local",
    connectionSegment1: "Segment 1",
    connectionSegment2: "Segment 2",
    connectionSegmentDepartureToTransfer: "Plecare → Punct de transfer",
    connectionSegmentTransferToDestination: "Punct de transfer → Destinație",
    connectionTransfer: "Transfer",
    connectionImportedSegments: "Segmente importate",
    connectionImportedReadonly: "Conexiune importata — campurile structurale sunt read-only",
    connectionSegmentsReadonly: "Segmente (read-only)",
    connectionPosition: "Pozitie",
    connectionSegment1Helper: "Segmentul 1 defineste ancora de plecare pana la orasul de transfer. Backend-ul extinde automat toate combinatiile eligibile.",
    connectionSegment2Helper: "Segmentul 2 defineste ancora de la orasul de transfer pana la destinatie. Combinatiile finale sunt generate automat de backend.",
    connectionSegment1HelperEdit: "Ancora segment 1: punct de plecare pana la transfer.",
    connectionSegment2HelperEdit: "Ancora segment 2: transfer pana la destinatie.",
    connectionAnchorsAlert: "Segmentele selectate sunt ancore. Backend-ul extinde automat combinatiile eligibile intre cele doua segmente.",
    connectionBsBsImportInfo: "Importul BS+BS foloseste endpoint-ul dedicat /connections/import-bs.",
    connectionSettings: "Setări conexiune",
    connectionStatus: "Status",
    connectionStatusDraft: "Draft",
    connectionStatusActive: "Activ",
    connectionStatusInactive: "Inactiv",
    connectionStatusPartial: "Parcialmente activa",
    connectionManualStatus: "Estado manual",
    connectionManualStatusHelper: "Este interruptor controla la intención del operador. La publicación en plataformas se muestra por separado.",
    connectionPublicationStatus: "Publicación en plataformas",
    connectionPublicationPublished: "Publicada",
    connectionPublicationPendingRebuild: "Reconstrucción pendiente",
    connectionPublicationBlocked: "Bloqueada",
    connectionPublicationRebuildFailed: "Error de reconstrucción",
    connectionPublicationUnpublished: "No publicada",
    connectionPublicationPartial: "Publicada parcialmente",
    connectionRebuildStatus: "Última reconstrucción",
    connectionRebuildSucceeded: "Correcta",
    connectionRebuildUnpublished: "Sin resultado publicado",
    connectionRebuildPartial: "Resultados de reconstrucción mixtos",
    connectionPublishedGenerationAt: "Generación publicada: {date}",
    connectionRebuildCheckedAt: "Reconstrucción comprobada: {date}",
    connectionPublicationReason: "Motivo: {reason}",
    connectionPublicationCheckedAt: "Comprobado: {date}",
    connectionPublicationWarningTitle: "Estado de publicación: {status}",
    connectionRebuildWarningTitle: "Última reconstrucción: {status}",
    connectionPublicationPartialDescription: "Algunos horarios no se muestran actualmente en las plataformas. Revisa cada horario abajo.",
    connectionPublicationUnpublishedDescription: "Actualmente no se muestra ningún horario de esta conexión en las plataformas.",
    connectionPublicationBlockedDescription: "La conexión no puede mostrarse actualmente en las plataformas. Corrige el problema de ruta indicado abajo.",
    connectionPublicationRebuildFailedDescription: "Falló la última reconstrucción de publicación. El estado manual del operador no cambió.",
    connectionRebuildFailedLiveDescription: "Falló la última reconstrucción, pero la generación publicada anterior sigue mostrándose en las plataformas.",
    connectionRebuildFailedNoLiveDescription: "Falló la última reconstrucción y actualmente no hay ninguna oferta mostrada en las plataformas.",
    connectionRebuildFailedPartialLiveDescription: "La última reconstrucción tiene errores. Solo siguen mostrándose los horarios marcados como publicados.",
    connectionRebuildFailedUnknownLiveDescription: "Falló la última reconstrucción. Esta respuesta antigua no confirma si sigue mostrándose una generación anterior.",
    connectionPublicationReasonManualInactive: "El estado manual está inactivo.",
    connectionPublicationReasonParentRouteMissing: "Una ruta principal ya no existe.",
    connectionPublicationReasonParentRouteInactive: "Una ruta principal está inactiva.",
    connectionPublicationReasonAnchorStopMissing: "Una parada de la conexión ya no existe.",
    connectionPublicationReasonAnchorStopRouteMismatch: "Una parada de la conexión ya no pertenece a la ruta seleccionada.",
    connectionPublicationReasonAnchorStopOrderInvalid: "Las paradas de la conexión ya no tienen un orden válido.",
    connectionPublicationReasonScheduleMissing: "Un horario seleccionado ya no existe.",
    connectionPublicationReasonAnchorTimeMissing: "Falta la hora de llegada o salida en una parada de la conexión.",
    connectionPublicationReasonTransferContinuity: "Los dos segmentos ya no coinciden en el mismo punto de transbordo.",
    connectionPublicationReasonTransferTimeSource: "No se puede calcular el tiempo de transbordo con el horario actual.",
    connectionPublicationReasonNoSegment1Pairs: "El segmento 1 no tiene pares de rutas vendibles.",
    connectionPublicationReasonNoSegment2Pairs: "El segmento 2 no tiene pares de rutas vendibles.",
    connectionPublicationReasonNoCombinations: "Los horarios seleccionados no tienen combinaciones de conexión vendibles.",
    connectionPublicationReasonTemporaryFailure: "Un error temporal impidió comprobar la publicación. Se volverá a intentar.",
    connectionPublicationReasonBuildFailure: "Falló la reconstrucción de la publicación en plataformas.",
    connectionPublicationReasonInvalidSegments: "La estructura de segmentos de la conexión no es válida.",
    connectionTransferTimeMinutes: "Timp transfer (minute)",
    connectionFeePerPassenger: "Taxa per pasager",
    connectionFeeCurrency: "Valuta taxa",
    connectionFeeCurrencyPlaceholder: "Valuta",
    connectionCurrency: "Valuta conexiunii",
    connectionCurrencyPlaceholder: "Valuta",
    connectionCurrencyHelper: "Valuta totalului conexiunii — separată de valuta taxei.",
    connectionRefundPolicyLabel: "Politica de refund",
    connectionRefundPolicyPlaceholder: "Selecteaza o politica de refund",
    connectionRefundPolicyHelper: "Refundurile la anulare folosesc politica selectata cand conexiunea este vanduta.",
    connectionRefundPolicyDisabledBs: "Politicile de refund nu pot fi atasate conexiunilor importate (BusSystem).",
    connectionRefundPolicySaved: "Politica de refund a fost actualizata.",
    connectionRefundPolicySaveError: "Nu am putut salva politica de refund.",
    connectionFrom: "De la",
    connectionTo: "Pana la",
    connectionCompanyNum: "Companie {num}",
    connectionRoute: "Ruta",
    connectionOpenRoute: "Deschide ruta",
    connectionTime: "Ora",
    connectionSchedulePairsTitle: "Pares de horarios",
    connectionSchedulePairsHelper: "Selecciona el horario exacto de cada segmento. El primer par es el ancla usada para previsualizar la ruta.",
    connectionSchedulePairsSegment1: "Horario del segmento 1",
    connectionSchedulePairsSegment2: "Horario del segmento 2",
    connectionSchedulePairsAdd: "Añadir par",
    connectionSchedulePairsRemove: "Eliminar par",
    connectionSchedulePairsRemoveExistingConfirm: "Este horario guardado se eliminará al guardar. La operación puede bloquearse si tiene reservas u otras dependencias. ¿Continuar?",
    connectionSchedulePairStatus: "Estado",
    connectionSchedulePairStatusNew: "Nuevo",
    connectionConfirm: "Confirmar",
    connectionCancel: "Cancelar",
    connectionSchedulePairsGenerateWeek: "Generar semana",
    connectionSchedulePairsAutoUnavailable: "La generación segura requiere las horas efectivas de llegada y salida en el punto de transbordo y un límite máximo de espera. Selecciona cada par explícitamente.",
    connectionSchedulePairsEmpty: "Añade al menos un par de horarios.",
    connectionSchedulePairsRequired: "Se requiere al menos un par de horarios.",
    connectionSchedulePairsIncomplete: "Completa ambos horarios en cada fila.",
    connectionSchedulePairsDuplicate: "Este par de horarios ya existe.",
    connectionSchedulePairsGenerated: "Se generaron {count} pares inequívocos.",
    connectionSchedulePairsGeneratedWithAmbiguous: "Se generaron {count} pares. {ambiguous} grupos de día y paridad tienen varios horarios y requieren una selección explícita.",
    connectionScheduleEveryWeek: "cada semana",
    connectionScheduleOddWeeks: "semanas impares",
    connectionScheduleEvenWeeks: "semanas pares",
    connectionFamilyScheduleCount: "{count} horarios",
    connectionTransferStation: "Statie de transfer",
    connectionFromStation: "De la",
    connectionToStation: "Pana la",
    connectionSaved: "Conexiune salvata",
    connectionCreated: "Conexiune creata",
    connectionBsBsImported: "Conexiune BS+BS importata",
    connectionStatusUpdated: "Status actualizat",
    connectionFamilyActivationSuccess: "Se activaron los {total} horarios.",
    connectionFamilyActivationNone: "No se pudo activar ningún horario (0/{total}). Revisa los horarios no válidos.",
    connectionFamilyActivationPartial: "Se activaron {activated} de {total} horarios. La familia sigue parcialmente activa.",
    connectionFamilyDeactivationSuccess: "Se desactivaron los {total} horarios.",
    connectionFamilyDeactivationIncomplete: "No se desactivaron todos los horarios ({deactivated}/{total}). Actualiza y vuelve a intentarlo.",
    connectionSaveError: "Eroare la salvare",
    connectionRoutesLoadError: "Eroare la incarcarea rutelor",
    connectionScheduleLoadError: "Eroare la incarcarea orarului",
    connectionStationsLoadError: "Eroare la incarcarea statiilor",
    connectionSegment1ValidPairs: "Segment 1 perechi valide:",
    connectionSegment2ValidPairs: "Segment 2 perechi valide:",
    connectionTotalCombinations: "Total combinatii:",
    connectionNoCombinationsEdit: "Nu exista combinatii vandabile pentru configuratia curenta.",
    connectionNoCombinationsCreate: "Nu exista combinatii vandabile pentru ancorele selectate.",
    connectionFewCombinationsEdit: "Numar mic de combinatii generate. Verificati segmentele ancora.",
    connectionFewCombinationsCreate: "Numar mic de combinatii generate. Verificati preturile si opririle.",
    connectionCombinationsUpdated: "Combinatiile au fost actualizate cu succes.",
    connectionCombinationsGenerated: "Combinatiile au fost generate cu succes.",
    connectionErrorSessionExpired: "Sesiune expirata. Va rugam sa va autentificati din nou.",
    connectionErrorNoPermission: "Nu aveti permisiunea pentru aceasta actiune.",
    connectionErrorNotFound: "Resursa nu a fost gasita sau modulul nu este disponibil.",
    connectionErrorNoSegment1Pairs: "Segmentul 1 nu are perechi valide cu pret general. Ajustati ancora de plecare sau ruta.",
    connectionErrorNoSegment2Pairs: "Segmentul 2 nu are perechi valide cu pret general. Ajustati ancora de transfer sau destinatia.",
    connectionErrorNoCombinations: "Nu exista combinatii vandabile intre cele doua ancore. Verificati preturile si opririle.",
    connectionErrorInvalidTransferStop: "Statia de transfer selectata nu este valida pentru ruta segmentului.",
    connectionErrorInvalidTransferTimeSource: "Nu se poate calcula timpul de transfer — datele de orar lipsesc sau sunt incomplete.",
    connectionErrorTransferContinuity: "Orasul de transfer trebuie sa fie acelasi intre cele doua segmente.",
    connectionErrorFamilyMemberInUse: "Este horario no se puede eliminar ni reemplazar porque tiene reservas u otras dependencias.",
    connectionErrorUnexpected: "Eroare neasteptata. Incercati din nou.",
    connectionBusIdLabel: "Bus",
    connectionRouteStatusLabel: "Status Rută",
    connectionRouteActive: "Activă",
    connectionRouteInactive: "Inactivă",
    connectionConnOnlyLabel: "Doar Conexiuni",
    connectionConnOnlyYes: "Doar con.",
    connectionTimeIdLabel: "ID Orar",
    connectionFromIdLabel: "De la",
    connectionToIdLabel: "Pana la",
    connectionTabSegments: "Segmentos",
    connectionTabSettings: "Configuración",
    connectionTabRouteInfo: "Info de Ruta",
    connectionPlatformsTab: "Platforme",
    connectionPlatformsHelper: "Alege pe ce platforme comerciale se vinde această conexiune. Dacă lista este goală, conexiunea nu apare pe nicio platformă.",
    connectionPlatformsSaved: "Platformele conexiunii au fost salvate.",
    connectionPlatformsSaveError: "Nu s-au putut salva platformele conexiunii.",
    connectionDiscard: "Renunță",
    connectionPaymentMethodsTab: "Metode de plata",
    connectionPaymentMethodSaveError: "Eroare la salvare metoda de plata",
    connectionPlatformPaymentIndependentHint: "Metodele de plată ale conexiunii se configurează per platformă comercială și sunt independente de rutele segmentelor.",
    connectionDiagArrival: "Sosire",
    connectionHandoffTitle: "Detalii transfer",
    connectionDropoff: "Coborâre Segment 1",
    connectionPickup: "Îmbarcare Segment 2",
    connectionWaitingTime: "Timp de așteptare",
    connectionTransferTime: "Timp de conexiune",
    platformPaymentTableTitle: "Payment methods per platform",
    platformPaymentTableDescription: "Configure how passengers pay on each commercial platform.",
    platformPaymentColumnPlatform: "Platform",
    platformPaymentColumnCash: "Cash",
    platformPaymentCashAddAll: "Add all",
    platformPaymentApplyToAll: "Apply to all platforms",
    platformPaymentColumnOnline: "Online payment",
    platformPaymentColumnStatus: "Status",
    platformPaymentStatusActive: "Active",
    platformPaymentStatusLocked: "Not visible · locked",
    platformPaymentStatusInvalid: "Invalid",
    platformPaymentEmpty: "No commercial platforms attached. Add platforms in the Platforms tab to configure payments.",
    platformPaymentDiscard: "Discard",
    platformPaymentSave: "Save changes",
    platformPaymentSaveSuccess: "Payment configuration saved",
    platformPaymentSaveError: "Error saving payment configuration",
    platformPaymentSaveValidation: "Please review the highlighted rows",
    platformPaymentErrorVisibleMissingMethod: "Choose Cash or an Online method.",
    platformPaymentErrorGeneric: "Invalid configuration.",
    platformPaymentOnlineNone: "None",
    platformPaymentOnlineMaib: "MAIB",
    platformPaymentOnlineNetopia: "Netopia",
    platformPaymentOnlineNetopiaConfigOnly: "Netopia (configuration only)",
    platformPaymentOnlineCarrierManaged: "Carrier-managed online",
    platformPaymentUnknownPlatform: "Unknown platform",
    platformPaymentReason_visible_platform_missing_method: "Choose Cash or an Online method.",
    platformPaymentReason_visible_platform_missing_assignment: "Assignment missing for this visible platform.",
    platformPaymentReason_duplicate_platform_assignment: "Duplicate platform assignment.",
    platformPaymentReason_unknown_hosted_method: "Online method not supported.",
    platformPaymentReason_method_not_hosted_family: "Online method must be hosted.",
    platformPaymentReason_hosted_method_not_in_registry: "Online method is not registered.",
    platformPaymentReason_registry_method_not_hosted: "Online method family mismatch.",
    platformPaymentReason_bus_system_not_hosted: "BusSystem cannot be used as hosted online method.",
    platformPaymentReason_cash_not_hosted_method: "Cash cannot be used as online method.",
    platformPaymentReason_inactive_non_visible: "Platform is no longer visible.",
    platformPaymentReason_platform_required: "Platform is required.",
    platformPaymentManagedByBusSystem: "Managed by BusSystem",
    platformPaymentCashOn: "On",
    platformPaymentCashOff: "Off",
  },
  de: {
    dashboard: "Instrumententafel",
    layoutBuilder: "Layout-Builder",
    craft: "Hergestellt",
    pages: "Seiten",
    profile: "Profil",
    profileOverview: "Überblick",
    projects: "Projekte",
    campaigns: "Kampagnen",
    documents: "Unterlagen",
    connections: "Anschlüsse",
    wizards: "Zauberer",
    horizontal: "Horizontal",
    vertical: "Vertikal",
    account: "Konto",
    accountOverview: "Überblick",
    settings: "Die Einstellungen",
    authentication: "Authentifizierung",
    basicFlow: "Grundfluss",
    signIn: "Einloggen",
    signUp: "Anmelden",
    passwordReset: "Passwort zurücksetzen",
    multiStepSignUp: "Multi-Steps-Anmeldung",
    error404: "Fehler 404",
    error500: "Fehler 500",
    apps: "Apps",
    chat: "Plaudern",
    widgets: "Widgets",
    widgetsLists: "Listen",
    widgetsStatistics: "Statistiken",
    widgetsCharts: "Diagramme",
    widgetsMixed: "Gemischt",
    widgetsTables: "Tabellen",
    widgetsFeeds: "Einspeisungen",
    changelog: "Änderungsprotokoll",
    docsAndComponents: "Dokumente & Komponenten",
    megaMenu: "Mega-Menü",
    exampleLink: "Beispiellink",
    modals: "Modale",
    general: "Allgemeines",
    inviteFriends: "Freunde Einladen",
    viewUsers: "Benutzer Anzeigen.",
    upgradePlan: "Upgrade-Plan",
    shareAndEarn: "Teilen & Verdienen",
    forms: "Formen",
    newTarget: "Neues Ziel",
    newCard: "Neue Karte",
    newAddress: "Neue Adresse",
    createAPIKey: "Api-Key Erstellen",
    twoFactorAuth: "Zwei Faktor Auth.",
    createApp: "App Erstellen",
    createAccount: "Benutzerkonto Erstellen",
    activity: "Aktivität",
    documentation: "Dokumentation",
    components: "Bauteile",
    resources: "Ressourcen",
    customers: "Kunden",
    gettingStarted: "Einstieg",
    customersListing: "Kundenauflistung",
    customerDetails: "Kundenangaben",
    calendarApp: "Kalender",
    subscriptions: "Abonnements",
    getStarted: "Einstieg",
    subscriptionList: "Abonnementliste",
    addSubscription: "Subskription Hinzufügen.",
    viewSubscription: "Abonnement Anzeigen.",
    connectionRouteInfoTitle: "Informatii ruta",
    connectionRouteInfoRouteAndPricesTab: "Traseu & Prețuri",
    connectionRouteInfoRouteTab: "Traseu & Adrese",
    connectionRouteInfoLocality: "Localitate",
    connectionRouteInfoAddress: "Adresa",
    connectionRouteInfoToAddress: "La adresa",
    connectionRouteInfoTransfer: "Transfer",
    connectionRouteInfoPriceCategoriesTab: "Categorii de preturi",
    connectionRouteInfoPriceCategory: "Categorie de pret",
    connectionRouteInfoPricesTab: "Prețuri",
    connectionRouteInfoPrice: "Pret",
    connectionRouteInfoArrival: "Localitatea de sosire",
    connectionRouteInfoTotal: "Total",
    connectionRouteInfoFareBreakdown: "Defalcare preț",
    connectionRouteInfoFareHint: "Alege punctul de îmbarcare și cel de coborâre pentru a vedea tariful exact al acelei călătorii.",
    connectionRouteInfoSelectPrompt: "Selectează plecarea și sosirea pentru a vedea prețul.",
    connectionRouteInfoConvertedNote: "Segmentele sunt normalizate și convertite în moneda conexiunii.",
    connectionRouteInfoDeparture: "Localitatea de plecare",
    connectionRouteInfoSegment: "Segment",
    connectionRouteInfoUnavailable: "Date indisponibile",
    connectionRouteInfoNoRoute: "Date indisponibile — segmentele nu au rute asociate.",
    connectionRouteInfoNoPriceData: "Date indisponibile — nu exista puncte de traseu sau categorii de pret.",
    connectionRouteInfoTbd: "TBD",
    connectionRouteInfoYes: "Da",
    connectionRouteInfoRouteLoadError: "Eroare la incarcarea datelor de ruta. Reincercati mai tarziu.",
    connectionRouteInfoPricesLoadError: "Eroare la incarcarea preturilor. Reincercati mai tarziu.",
    connectionRouteInfoAvailableIn: "Disponibil in",
    connectionRouteInfoSegmentLoadError: "Eroare la incarcarea datelor pentru acest segment.",
    connectionRouteInfoTransferIndicator: "Transfer",
    connectionRouteInfoDay1: "Lun",
    connectionRouteInfoDay2: "Mar",
    connectionRouteInfoDay3: "Mie",
    connectionRouteInfoDay4: "Joi",
    connectionRouteInfoDay5: "Vin",
    connectionRouteInfoDay6: "Sam",
    connectionRouteInfoDay7: "Dum",
    connectionFinalPrice: "Pret final conexiune",
    connectionAuthoritativeTotal: "Total destinatie configurata",
    connectionTransferMode: "Mod transfer",
    connectionTransferModeOrganized: "Organizat",
    connectionTransferModeUnorganized: "Neorganizat",
    connectionTransferInstructions: "Instructiuni de transfer",
    connectionTransferInstructionsRo: "Romana (RO)",
    connectionTransferInstructionsRu: "Rusa (RU)",
    connectionTransferInstructionsEn: "Engleza (EN)",
    connectionTransferInstructionsUk: "Ucraineana (UK)",
    connectionDepartureOverride: "Suprascriere instructiuni transfer plecare",
    connectionDepartureOverrideLoad: "Incarca suprascriere",
    connectionDepartureOverrideSave: "Salveaza suprascriere",
    connectionDepartureOverrideWarning: "Modificarile afecteaza TOATE rezervarile din aceasta plecare, nu doar cea curenta.",
    connectionDepartureOverrideActive: "Suprascriere activa — se vor folosi instructiunile specifice plecarii",
    connectionDepartureOverrideNone: "Fara suprascriere — se folosesc valorile implicite ale conexiunii",
    connectionTransferInstructionsPlaceholderRo: "Instructiuni transfer (RO)",
    connectionTransferInstructionsPlaceholderRu: "Instructiuni transfer (RU)",
    connectionTransferInstructionsPlaceholderEn: "Instructiuni transfer (EN)",
    connectionTransferInstructionsPlaceholderUk: "Instructiuni transfer (UK)",
    connectionCreateTitle: "Creaza conexiune",
    connectionEditTitle: "Conexiune",
    connectionEditTitleWithId: "Conexiune #{id}",
    connectionEditTitleWithIdAndRoute: "Conexiune #{id} — {route}",
    connectionSave: "Salveaza",
    connectionImportBsBs: "Importa BS+BS",
    connectionCreate: "Creaza",
    connectionType: "Tip conexiune",
    connectionTypeLocalLocal: "Local + Local",
    connectionTypeBsBsImport: "BS + BS (import)",
    connectionTypeBsBsBadge: "BS + BS (importat)",
    connectionTypeLocalLocalBadge: "Local + Local",
    connectionSegment1: "Segment 1",
    connectionSegment2: "Segment 2",
    connectionSegmentDepartureToTransfer: "Plecare → Punct de transfer",
    connectionSegmentTransferToDestination: "Punct de transfer → Destinație",
    connectionTransfer: "Transfer",
    connectionImportedSegments: "Segmente importate",
    connectionImportedReadonly: "Conexiune importata — campurile structurale sunt read-only",
    connectionSegmentsReadonly: "Segmente (read-only)",
    connectionPosition: "Pozitie",
    connectionSegment1Helper: "Segmentul 1 defineste ancora de plecare pana la orasul de transfer. Backend-ul extinde automat toate combinatiile eligibile.",
    connectionSegment2Helper: "Segmentul 2 defineste ancora de la orasul de transfer pana la destinatie. Combinatiile finale sunt generate automat de backend.",
    connectionSegment1HelperEdit: "Ancora segment 1: punct de plecare pana la transfer.",
    connectionSegment2HelperEdit: "Ancora segment 2: transfer pana la destinatie.",
    connectionAnchorsAlert: "Segmentele selectate sunt ancore. Backend-ul extinde automat combinatiile eligibile intre cele doua segmente.",
    connectionBsBsImportInfo: "Importul BS+BS foloseste endpoint-ul dedicat /connections/import-bs.",
    connectionSettings: "Setări conexiune",
    connectionStatus: "Status",
    connectionStatusDraft: "Draft",
    connectionStatusActive: "Activ",
    connectionStatusInactive: "Inactiv",
    connectionTransferTimeMinutes: "Timp transfer (minute)",
    connectionFeePerPassenger: "Taxa per pasager",
    connectionFeeCurrency: "Valuta taxa",
    connectionFeeCurrencyPlaceholder: "Valuta",
    connectionCurrency: "Valuta conexiunii",
    connectionCurrencyPlaceholder: "Valuta",
    connectionCurrencyHelper: "Valuta totalului conexiunii — separată de valuta taxei.",
    connectionRefundPolicyLabel: "Politica de refund",
    connectionRefundPolicyPlaceholder: "Selecteaza o politica de refund",
    connectionRefundPolicyHelper: "Refundurile la anulare folosesc politica selectata cand conexiunea este vanduta.",
    connectionRefundPolicyDisabledBs: "Politicile de refund nu pot fi atasate conexiunilor importate (BusSystem).",
    connectionRefundPolicySaved: "Politica de refund a fost actualizata.",
    connectionRefundPolicySaveError: "Nu am putut salva politica de refund.",
    connectionFrom: "De la",
    connectionTo: "Pana la",
    connectionCompanyNum: "Companie {num}",
    connectionRoute: "Ruta",
    connectionOpenRoute: "Deschide ruta",
    connectionTime: "Ora",
    connectionStatusPartial: "Teilweise aktiv",
    connectionManualStatus: "Manueller Status",
    connectionManualStatusHelper: "Dieser Schalter steuert die Absicht des Betreibers. Die Plattformveröffentlichung wird separat angezeigt.",
    connectionPublicationStatus: "Plattformveröffentlichung",
    connectionPublicationPublished: "Veröffentlicht",
    connectionPublicationPendingRebuild: "Neuaufbau ausstehend",
    connectionPublicationBlocked: "Blockiert",
    connectionPublicationRebuildFailed: "Neuaufbau fehlgeschlagen",
    connectionPublicationUnpublished: "Nicht veröffentlicht",
    connectionPublicationPartial: "Teilweise veröffentlicht",
    connectionRebuildStatus: "Letzter Neuaufbau",
    connectionRebuildSucceeded: "Erfolgreich",
    connectionRebuildUnpublished: "Kein veröffentlichtes Ergebnis",
    connectionRebuildPartial: "Gemischte Neuaufbauergebnisse",
    connectionPublishedGenerationAt: "Veröffentlichte Generation: {date}",
    connectionRebuildCheckedAt: "Neuaufbau geprüft: {date}",
    connectionPublicationReason: "Grund: {reason}",
    connectionPublicationCheckedAt: "Geprüft: {date}",
    connectionPublicationWarningTitle: "Veröffentlichungsstatus: {status}",
    connectionRebuildWarningTitle: "Letzter Neuaufbau: {status}",
    connectionPublicationPartialDescription: "Einige Fahrpläne werden derzeit nicht auf den Plattformen angezeigt. Prüfe jeden Fahrplan unten.",
    connectionPublicationUnpublishedDescription: "Derzeit wird kein Fahrplan dieser Verbindung auf den Plattformen angezeigt.",
    connectionPublicationBlockedDescription: "Die Verbindung kann derzeit nicht auf den Plattformen angezeigt werden. Behebe das unten angezeigte Routenproblem.",
    connectionPublicationRebuildFailedDescription: "Der letzte Veröffentlichungsaufbau ist fehlgeschlagen. Der manuelle Status wurde nicht geändert.",
    connectionRebuildFailedLiveDescription: "Der letzte Neuaufbau ist fehlgeschlagen, aber die vorherige veröffentlichte Generation wird weiterhin auf den Plattformen angezeigt.",
    connectionRebuildFailedNoLiveDescription: "Der letzte Neuaufbau ist fehlgeschlagen und derzeit wird kein Angebot auf den Plattformen angezeigt.",
    connectionRebuildFailedPartialLiveDescription: "Beim letzten Neuaufbau sind Fehler aufgetreten. Nur als veröffentlicht markierte Fahrpläne bleiben sichtbar.",
    connectionRebuildFailedUnknownLiveDescription: "Der letzte Neuaufbau ist fehlgeschlagen. Diese ältere Antwort bestätigt nicht, ob eine vorherige Generation weiterhin angezeigt wird.",
    connectionPublicationReasonManualInactive: "Der manuelle Status ist inaktiv.",
    connectionPublicationReasonParentRouteMissing: "Eine übergeordnete Route existiert nicht mehr.",
    connectionPublicationReasonParentRouteInactive: "Eine übergeordnete Route ist inaktiv.",
    connectionPublicationReasonAnchorStopMissing: "Eine Haltestelle der Verbindung existiert nicht mehr.",
    connectionPublicationReasonAnchorStopRouteMismatch: "Eine Haltestelle gehört nicht mehr zur ausgewählten Route.",
    connectionPublicationReasonAnchorStopOrderInvalid: "Die Haltestellen der Verbindung haben keine gültige Reihenfolge mehr.",
    connectionPublicationReasonScheduleMissing: "Ein ausgewählter Fahrplan existiert nicht mehr.",
    connectionPublicationReasonAnchorTimeMissing: "An einer Haltestelle fehlt die Ankunfts- oder Abfahrtszeit.",
    connectionPublicationReasonTransferContinuity: "Die beiden Segmente treffen sich nicht mehr am selben Umstiegspunkt.",
    connectionPublicationReasonTransferTimeSource: "Die Umstiegszeit kann aus dem aktuellen Fahrplan nicht berechnet werden.",
    connectionPublicationReasonNoSegment1Pairs: "Segment 1 hat keine verkaufbaren Routenpaare.",
    connectionPublicationReasonNoSegment2Pairs: "Segment 2 hat keine verkaufbaren Routenpaare.",
    connectionPublicationReasonNoCombinations: "Die ausgewählten Fahrpläne haben keine verkaufbaren Verbindungskombinationen.",
    connectionPublicationReasonTemporaryFailure: "Ein vorübergehender Fehler verhinderte die Veröffentlichungsprüfung. Sie wird wiederholt.",
    connectionPublicationReasonBuildFailure: "Der Neuaufbau der Plattformveröffentlichung ist fehlgeschlagen.",
    connectionPublicationReasonInvalidSegments: "Die Segmentstruktur der Verbindung ist ungültig.",
    connectionSchedulePairsTitle: "Fahrplanpaare",
    connectionSchedulePairsHelper: "Wähle den genauen Fahrplan für jedes Segment. Das erste Paar ist der Anker für die Routenvorschau.",
    connectionSchedulePairsSegment1: "Fahrplan Segment 1",
    connectionSchedulePairsSegment2: "Fahrplan Segment 2",
    connectionSchedulePairsAdd: "Paar hinzufügen",
    connectionSchedulePairsRemove: "Paar entfernen",
    connectionSchedulePairsRemoveExistingConfirm: "Dieser gespeicherte Fahrplan wird beim Speichern entfernt. Der Vorgang kann blockiert werden, wenn Buchungen oder andere Abhängigkeiten bestehen. Fortfahren?",
    connectionSchedulePairStatus: "Status",
    connectionSchedulePairStatusNew: "Neu",
    connectionConfirm: "Bestätigen",
    connectionCancel: "Abbrechen",
    connectionSchedulePairsGenerateWeek: "Woche generieren",
    connectionSchedulePairsAutoUnavailable: "Eine sichere Generierung erfordert die tatsächlichen Ankunfts- und Abfahrtszeiten am Umstiegspunkt sowie eine maximale Wartezeit. Wähle jedes Paar ausdrücklich aus.",
    connectionSchedulePairsEmpty: "Füge mindestens ein Fahrplanpaar hinzu.",
    connectionSchedulePairsRequired: "Mindestens ein Fahrplanpaar ist erforderlich.",
    connectionSchedulePairsIncomplete: "Vervollständige beide Fahrpläne in jeder Zeile.",
    connectionSchedulePairsDuplicate: "Dieses Fahrplanpaar ist bereits vorhanden.",
    connectionSchedulePairsGenerated: "{count} eindeutige Fahrplanpaare wurden generiert.",
    connectionSchedulePairsGeneratedWithAmbiguous: "{count} Paare wurden generiert. {ambiguous} Tag-/Paritätsgruppen enthalten mehrere Fahrpläne und müssen ausdrücklich ausgewählt werden.",
    connectionScheduleEveryWeek: "jede Woche",
    connectionScheduleOddWeeks: "ungerade Wochen",
    connectionScheduleEvenWeeks: "gerade Wochen",
    connectionFamilyScheduleCount: "{count} Fahrpläne",
    connectionTransferStation: "Statie de transfer",
    connectionFromStation: "De la",
    connectionToStation: "Pana la",
    connectionSaved: "Conexiune salvata",
    connectionCreated: "Conexiune creata",
    connectionBsBsImported: "Conexiune BS+BS importata",
    connectionStatusUpdated: "Status actualizat",
    connectionFamilyActivationSuccess: "Alle {total} Fahrpläne wurden aktiviert.",
    connectionFamilyActivationNone: "Kein Fahrplan konnte aktiviert werden (0/{total}). Prüfe die ungültigen Fahrpläne.",
    connectionFamilyActivationPartial: "{activated} von {total} Fahrplänen wurden aktiviert. Die Familie bleibt teilweise aktiv.",
    connectionFamilyDeactivationSuccess: "Alle {total} Fahrpläne wurden deaktiviert.",
    connectionFamilyDeactivationIncomplete: "Nicht alle Fahrpläne wurden deaktiviert ({deactivated}/{total}). Aktualisiere die Seite und versuche es erneut.",
    connectionSaveError: "Eroare la salvare",
    connectionRoutesLoadError: "Eroare la incarcarea rutelor",
    connectionScheduleLoadError: "Eroare la incarcarea orarului",
    connectionStationsLoadError: "Eroare la incarcarea statiilor",
    connectionSegment1ValidPairs: "Segment 1 perechi valide:",
    connectionSegment2ValidPairs: "Segment 2 perechi valide:",
    connectionTotalCombinations: "Total combinatii:",
    connectionNoCombinationsEdit: "Nu exista combinatii vandabile pentru configuratia curenta.",
    connectionNoCombinationsCreate: "Nu exista combinatii vandabile pentru ancorele selectate.",
    connectionFewCombinationsEdit: "Numar mic de combinatii generate. Verificati segmentele ancora.",
    connectionFewCombinationsCreate: "Numar mic de combinatii generate. Verificati preturile si opririle.",
    connectionCombinationsUpdated: "Combinatiile au fost actualizate cu succes.",
    connectionCombinationsGenerated: "Combinatiile au fost generate cu succes.",
    connectionErrorSessionExpired: "Sesiune expirata. Va rugam sa va autentificati din nou.",
    connectionErrorNoPermission: "Nu aveti permisiunea pentru aceasta actiune.",
    connectionErrorNotFound: "Resursa nu a fost gasita sau modulul nu este disponibil.",
    connectionErrorNoSegment1Pairs: "Segmentul 1 nu are perechi valide cu pret general. Ajustati ancora de plecare sau ruta.",
    connectionErrorNoSegment2Pairs: "Segmentul 2 nu are perechi valide cu pret general. Ajustati ancora de transfer sau destinatia.",
    connectionErrorNoCombinations: "Nu exista combinatii vandabile intre cele doua ancore. Verificati preturile si opririle.",
    connectionErrorInvalidTransferStop: "Statia de transfer selectata nu este valida pentru ruta segmentului.",
    connectionErrorInvalidTransferTimeSource: "Nu se poate calcula timpul de transfer — datele de orar lipsesc sau sunt incomplete.",
    connectionErrorTransferContinuity: "Orasul de transfer trebuie sa fie acelasi intre cele doua segmente.",
    connectionErrorFamilyMemberInUse: "Dieser Fahrplan kann nicht entfernt oder ersetzt werden, weil Buchungen oder andere Abhängigkeiten bestehen.",
    connectionErrorUnexpected: "Eroare neasteptata. Incercati din nou.",
    connectionBusIdLabel: "Bus",
    connectionRouteStatusLabel: "Status Rută",
    connectionRouteActive: "Activă",
    connectionRouteInactive: "Inactivă",
    connectionConnOnlyLabel: "Doar Conexiuni",
    connectionConnOnlyYes: "Doar con.",
    connectionTimeIdLabel: "ID Orar",
    connectionFromIdLabel: "De la",
    connectionToIdLabel: "Pana la",
    connectionTabSegments: "Segmente",
    connectionTabSettings: "Einstellungen",
    connectionTabRouteInfo: "Routeninfo",
    connectionPlatformsTab: "Plattformen",
    connectionPlatformsHelper: "Wählen Sie die Handelsplattformen, auf denen diese Verbindung verkauft wird. Eine leere Auswahl blendet die Verbindung auf allen Plattformen aus.",
    connectionPlatformsSaved: "Verbindungsplattformen gespeichert.",
    connectionPlatformsSaveError: "Verbindungsplattformen konnten nicht gespeichert werden.",
    connectionDiscard: "Verwerfen",
    connectionPaymentMethodsTab: "Zahlungsmethoden",
    connectionPlatformPaymentIndependentHint: "Die Zahlungsmethoden der Verbindung werden pro Handelsplattform konfiguriert und sind unabhängig von den Streckensegmenten.",
    connectionPaymentMethodSaveError: "Fehler beim Speichern der Zahlungsmethode",
    connectionDiagArrival: "Sosire",
    connectionHandoffTitle: "Detalii transfer",
    connectionDropoff: "Coborâre Segment 1",
    connectionPickup: "Îmbarcare Segment 2",
    connectionWaitingTime: "Timp de așteptare",
    connectionTransferTime: "Timp de conexiune",
    platformPaymentTableTitle: "Payment methods per platform",
    platformPaymentTableDescription: "Configure how passengers pay on each commercial platform.",
    platformPaymentColumnPlatform: "Platform",
    platformPaymentColumnCash: "Cash",
    platformPaymentCashAddAll: "Add all",
    platformPaymentApplyToAll: "Apply to all platforms",
    platformPaymentColumnOnline: "Online payment",
    platformPaymentColumnStatus: "Status",
    platformPaymentStatusActive: "Active",
    platformPaymentStatusLocked: "Not visible · locked",
    platformPaymentStatusInvalid: "Invalid",
    platformPaymentEmpty: "No commercial platforms attached. Add platforms in the Platforms tab to configure payments.",
    platformPaymentDiscard: "Discard",
    platformPaymentSave: "Save changes",
    platformPaymentSaveSuccess: "Payment configuration saved",
    platformPaymentSaveError: "Error saving payment configuration",
    platformPaymentSaveValidation: "Please review the highlighted rows",
    platformPaymentErrorVisibleMissingMethod: "Choose Cash or an Online method.",
    platformPaymentErrorGeneric: "Invalid configuration.",
    platformPaymentOnlineNone: "None",
    platformPaymentOnlineMaib: "MAIB",
    platformPaymentOnlineNetopia: "Netopia",
    platformPaymentOnlineNetopiaConfigOnly: "Netopia (configuration only)",
    platformPaymentOnlineCarrierManaged: "Carrier-managed online",
    platformPaymentUnknownPlatform: "Unknown platform",
    platformPaymentReason_visible_platform_missing_method: "Choose Cash or an Online method.",
    platformPaymentReason_visible_platform_missing_assignment: "Assignment missing for this visible platform.",
    platformPaymentReason_duplicate_platform_assignment: "Duplicate platform assignment.",
    platformPaymentReason_unknown_hosted_method: "Online method not supported.",
    platformPaymentReason_method_not_hosted_family: "Online method must be hosted.",
    platformPaymentReason_hosted_method_not_in_registry: "Online method is not registered.",
    platformPaymentReason_registry_method_not_hosted: "Online method family mismatch.",
    platformPaymentReason_bus_system_not_hosted: "BusSystem cannot be used as hosted online method.",
    platformPaymentReason_cash_not_hosted_method: "Cash cannot be used as online method.",
    platformPaymentReason_inactive_non_visible: "Platform is no longer visible.",
    platformPaymentReason_platform_required: "Platform is required.",
    platformPaymentManagedByBusSystem: "Managed by BusSystem",
    platformPaymentCashOn: "On",
    platformPaymentCashOff: "Off",
  },
  ja: {
    dashboard: "ダッシュボード",
    layoutBuilder: "レイアウトビルダー",
    craft: "作成された",
    pages: "ページ",
    profile: "プロフィール",
    profileOverview: "概要",
    projects: "プロジェクト",
    campaigns: "キャンペーン",
    documents: "書類",
    connections: "接続",
    wizards: "ウィザード",
    horizontal: "横",
    vertical: "垂直",
    account: "アカウント",
    accountOverview: "概要",
    settings: "設定",
    authentication: "認証",
    basicFlow: "基本的な流れ",
    signIn: "サインイン",
    signUp: "サインアップ",
    passwordReset: "パスワードのリセット",
    multiStepSignUp: "マルチステップサインアップ",
    error404: "エラー404",
    error500: "エラー 500",
    apps: "アプリ",
    chat: "チャット",
    widgets: "ウィジェット",
    widgetsLists: "リスト",
    widgetsStatistics: "統計",
    widgetsCharts: "チャート",
    widgetsMixed: "混合",
    widgetsTables: "テーブル",
    widgetsFeeds: "フィード",
    changelog: "変更ログ",
    docsAndComponents: "ドキュメントとコンポーネント",
    megaMenu: "メガメニュー",
    exampleLink: "リンク例",
    modals: "モーダルズ",
    general: "一般",
    inviteFriends: "友達を招待",
    viewUsers: "ユーザーを表示します",
    upgradePlan: "アップグレードプラン",
    shareAndEarn: "シェア＆稼働",
    forms: "フォーム",
    newTarget: "新しいターゲット",
    newCard: "新しいカード",
    newAddress: "新しいアドレス",
    createAPIKey: "Apiキーを作成します",
    twoFactorAuth: "2つの要因Auth",
    createApp: "アプリを作成します",
    createAccount: "アカウントを作成する",
    activity: "アクティビティ",
    documentation: "ドキュメンテーション",
    components: "コンポーネント",
    resources: "資力",
    customers: "お客様のお客様",
    gettingStarted: "入門",
    customersListing: "顧客のリスト",
    customerDetails: "お客様の詳細",
    calendarApp: "カレンダー",
    subscriptions: "購読",
    getStarted: "入門",
    subscriptionList: "サブスクリプションリスト",
    addSubscription: "サブスクリプションを追加します",
    viewSubscription: "購読を見る",
    connectionRouteInfoTitle: "Informatii ruta",
    connectionRouteInfoRouteAndPricesTab: "Traseu & Prețuri",
    connectionRouteInfoRouteTab: "Traseu & Adrese",
    connectionRouteInfoLocality: "Localitate",
    connectionRouteInfoAddress: "Adresa",
    connectionRouteInfoToAddress: "La adresa",
    connectionRouteInfoTransfer: "Transfer",
    connectionRouteInfoPriceCategoriesTab: "Categorii de preturi",
    connectionRouteInfoPriceCategory: "Categorie de pret",
    connectionRouteInfoPricesTab: "Prețuri",
    connectionRouteInfoPrice: "Pret",
    connectionRouteInfoArrival: "Localitatea de sosire",
    connectionRouteInfoTotal: "Total",
    connectionRouteInfoFareBreakdown: "Defalcare preț",
    connectionRouteInfoFareHint: "Alege punctul de îmbarcare și cel de coborâre pentru a vedea tariful exact al acelei călătorii.",
    connectionRouteInfoSelectPrompt: "Selectează plecarea și sosirea pentru a vedea prețul.",
    connectionRouteInfoConvertedNote: "Segmentele sunt normalizate și convertite în moneda conexiunii.",
    connectionRouteInfoDeparture: "Localitatea de plecare",
    connectionRouteInfoSegment: "Segment",
    connectionRouteInfoUnavailable: "Date indisponibile",
    connectionRouteInfoNoRoute: "Date indisponibile — segmentele nu au rute asociate.",
    connectionRouteInfoNoPriceData: "Date indisponibile — nu exista puncte de traseu sau categorii de pret.",
    connectionRouteInfoTbd: "TBD",
    connectionRouteInfoYes: "Da",
    connectionRouteInfoRouteLoadError: "Eroare la incarcarea datelor de ruta. Reincercati mai tarziu.",
    connectionRouteInfoPricesLoadError: "Eroare la incarcarea preturilor. Reincercati mai tarziu.",
    connectionRouteInfoAvailableIn: "Disponibil in",
    connectionRouteInfoSegmentLoadError: "Eroare la incarcarea datelor pentru acest segment.",
    connectionRouteInfoTransferIndicator: "Transfer",
    connectionRouteInfoDay1: "Lun",
    connectionRouteInfoDay2: "Mar",
    connectionRouteInfoDay3: "Mie",
    connectionRouteInfoDay4: "Joi",
    connectionRouteInfoDay5: "Vin",
    connectionRouteInfoDay6: "Sam",
    connectionRouteInfoDay7: "Dum",
    connectionFinalPrice: "Pret final conexiune",
    connectionAuthoritativeTotal: "Total destinatie configurata",
    connectionTransferMode: "Mod transfer",
    connectionTransferModeOrganized: "Organizat",
    connectionTransferModeUnorganized: "Neorganizat",
    connectionTransferInstructions: "Instructiuni de transfer",
    connectionTransferInstructionsRo: "Romana (RO)",
    connectionTransferInstructionsRu: "Rusa (RU)",
    connectionTransferInstructionsEn: "Engleza (EN)",
    connectionTransferInstructionsUk: "Ucraineana (UK)",
    connectionDepartureOverride: "Suprascriere instructiuni transfer plecare",
    connectionDepartureOverrideLoad: "Incarca suprascriere",
    connectionDepartureOverrideSave: "Salveaza suprascriere",
    connectionDepartureOverrideWarning: "Modificarile afecteaza TOATE rezervarile din aceasta plecare, nu doar cea curenta.",
    connectionDepartureOverrideActive: "Suprascriere activa — se vor folosi instructiunile specifice plecarii",
    connectionDepartureOverrideNone: "Fara suprascriere — se folosesc valorile implicite ale conexiunii",
    connectionTransferInstructionsPlaceholderRo: "Instructiuni transfer (RO)",
    connectionTransferInstructionsPlaceholderRu: "Instructiuni transfer (RU)",
    connectionTransferInstructionsPlaceholderEn: "Instructiuni transfer (EN)",
    connectionTransferInstructionsPlaceholderUk: "Instructiuni transfer (UK)",
    connectionCreateTitle: "Creaza conexiune",
    connectionEditTitle: "Conexiune",
    connectionEditTitleWithId: "Conexiune #{id}",
    connectionEditTitleWithIdAndRoute: "Conexiune #{id} — {route}",
    connectionSave: "Salveaza",
    connectionImportBsBs: "Importa BS+BS",
    connectionCreate: "Creaza",
    connectionType: "Tip conexiune",
    connectionTypeLocalLocal: "Local + Local",
    connectionTypeBsBsImport: "BS + BS (import)",
    connectionTypeBsBsBadge: "BS + BS (importat)",
    connectionTypeLocalLocalBadge: "Local + Local",
    connectionSegment1: "Segment 1",
    connectionSegment2: "Segment 2",
    connectionSegmentDepartureToTransfer: "Plecare → Punct de transfer",
    connectionSegmentTransferToDestination: "Punct de transfer → Destinație",
    connectionTransfer: "Transfer",
    connectionImportedSegments: "Segmente importate",
    connectionImportedReadonly: "Conexiune importata — campurile structurale sunt read-only",
    connectionSegmentsReadonly: "Segmente (read-only)",
    connectionPosition: "Pozitie",
    connectionSegment1Helper: "Segmentul 1 defineste ancora de plecare pana la orasul de transfer. Backend-ul extinde automat toate combinatiile eligibile.",
    connectionSegment2Helper: "Segmentul 2 defineste ancora de la orasul de transfer pana la destinatie. Combinatiile finale sunt generate automat de backend.",
    connectionSegment1HelperEdit: "Ancora segment 1: punct de plecare pana la transfer.",
    connectionSegment2HelperEdit: "Ancora segment 2: transfer pana la destinatie.",
    connectionAnchorsAlert: "Segmentele selectate sunt ancore. Backend-ul extinde automat combinatiile eligibile intre cele doua segmente.",
    connectionBsBsImportInfo: "Importul BS+BS foloseste endpoint-ul dedicat /connections/import-bs.",
    connectionSettings: "Setări conexiune",
    connectionStatus: "Status",
    connectionStatusDraft: "Draft",
    connectionStatusActive: "Activ",
    connectionStatusInactive: "Inactiv",
    connectionTransferTimeMinutes: "Timp transfer (minute)",
    connectionFeePerPassenger: "Taxa per pasager",
    connectionFeeCurrency: "Valuta taxa",
    connectionFeeCurrencyPlaceholder: "Valuta",
    connectionCurrency: "Valuta conexiunii",
    connectionCurrencyPlaceholder: "Valuta",
    connectionCurrencyHelper: "Valuta totalului conexiunii — separată de valuta taxei.",
    connectionRefundPolicyLabel: "Politica de refund",
    connectionRefundPolicyPlaceholder: "Selecteaza o politica de refund",
    connectionRefundPolicyHelper: "Refundurile la anulare folosesc politica selectata cand conexiunea este vanduta.",
    connectionRefundPolicyDisabledBs: "Politicile de refund nu pot fi atasate conexiunilor importate (BusSystem).",
    connectionRefundPolicySaved: "Politica de refund a fost actualizata.",
    connectionRefundPolicySaveError: "Nu am putut salva politica de refund.",
    connectionFrom: "De la",
    connectionTo: "Pana la",
    connectionCompanyNum: "Companie {num}",
    connectionRoute: "Ruta",
    connectionOpenRoute: "Deschide ruta",
    connectionTime: "Ora",
    connectionStatusPartial: "一部有効",
    connectionManualStatus: "手動ステータス",
    connectionManualStatusHelper: "このスイッチは運行会社の意図を管理します。プラットフォーム公開状態は別に表示されます。",
    connectionPublicationStatus: "プラットフォーム公開",
    connectionPublicationPublished: "公開済み",
    connectionPublicationPendingRebuild: "再構築待ち",
    connectionPublicationBlocked: "ブロック中",
    connectionPublicationRebuildFailed: "再構築失敗",
    connectionPublicationUnpublished: "未公開",
    connectionPublicationPartial: "一部公開",
    connectionRebuildStatus: "最新の再構築",
    connectionRebuildSucceeded: "成功",
    connectionRebuildUnpublished: "公開結果なし",
    connectionRebuildPartial: "再構築結果が混在",
    connectionPublishedGenerationAt: "公開世代: {date}",
    connectionRebuildCheckedAt: "再構築確認日時: {date}",
    connectionPublicationReason: "理由: {reason}",
    connectionPublicationCheckedAt: "確認日時: {date}",
    connectionPublicationWarningTitle: "公開ステータス: {status}",
    connectionRebuildWarningTitle: "最新の再構築: {status}",
    connectionPublicationPartialDescription: "一部の運行時刻は現在プラットフォームに表示されていません。下の各運行時刻を確認してください。",
    connectionPublicationUnpublishedDescription: "この接続の運行時刻は現在プラットフォームに表示されていません。",
    connectionPublicationBlockedDescription: "この接続は現在プラットフォームに表示できません。下に示されたルートの問題を修正してください。",
    connectionPublicationRebuildFailedDescription: "前回の公開再構築に失敗しました。運行会社の手動ステータスは変更されていません。",
    connectionRebuildFailedLiveDescription: "最新の再構築に失敗しましたが、以前の公開世代は引き続きプラットフォームに表示されています。",
    connectionRebuildFailedNoLiveDescription: "最新の再構築に失敗し、現在プラットフォームに表示されているオファーはありません。",
    connectionRebuildFailedPartialLiveDescription: "最新の再構築に失敗した運行時刻があります。公開済みと表示された運行時刻のみ引き続き表示されます。",
    connectionRebuildFailedUnknownLiveDescription: "最新の再構築に失敗しました。この旧形式の応答では、以前の世代が表示されているか確認できません。",
    connectionPublicationReasonManualInactive: "手動ステータスが無効です。",
    connectionPublicationReasonParentRouteMissing: "親ルートが存在しません。",
    connectionPublicationReasonParentRouteInactive: "親ルートが無効です。",
    connectionPublicationReasonAnchorStopMissing: "接続地点が存在しません。",
    connectionPublicationReasonAnchorStopRouteMismatch: "接続地点が選択したルートに属していません。",
    connectionPublicationReasonAnchorStopOrderInvalid: "接続地点の順序が無効です。",
    connectionPublicationReasonScheduleMissing: "選択した運行時刻が存在しません。",
    connectionPublicationReasonAnchorTimeMissing: "接続地点の到着時刻または出発時刻がありません。",
    connectionPublicationReasonTransferContinuity: "2つの区間が同じ乗換地点で接続していません。",
    connectionPublicationReasonTransferTimeSource: "現在の運行時刻から乗換時間を計算できません。",
    connectionPublicationReasonNoSegment1Pairs: "区間1に販売可能なルートの組み合わせがありません。",
    connectionPublicationReasonNoSegment2Pairs: "区間2に販売可能なルートの組み合わせがありません。",
    connectionPublicationReasonNoCombinations: "選択した運行時刻に販売可能な接続の組み合わせがありません。",
    connectionPublicationReasonTemporaryFailure: "一時的なエラーにより公開確認ができませんでした。再試行されます。",
    connectionPublicationReasonBuildFailure: "プラットフォーム公開の再構築に失敗しました。",
    connectionPublicationReasonInvalidSegments: "接続区間の構造が無効です。",
    connectionSchedulePairsTitle: "運行時刻の組み合わせ",
    connectionSchedulePairsHelper: "各区間の正確な運行時刻を選択してください。最初の組み合わせがルートプレビューの基準になります。",
    connectionSchedulePairsSegment1: "区間1の運行時刻",
    connectionSchedulePairsSegment2: "区間2の運行時刻",
    connectionSchedulePairsAdd: "組み合わせを追加",
    connectionSchedulePairsRemove: "組み合わせを削除",
    connectionSchedulePairsRemoveExistingConfirm: "保存済みの運行時刻は保存時に削除されます。予約や他の依存関係がある場合、この操作は拒否されることがあります。続行しますか？",
    connectionSchedulePairStatus: "状態",
    connectionSchedulePairStatusNew: "新規",
    connectionConfirm: "確認",
    connectionCancel: "キャンセル",
    connectionSchedulePairsGenerateWeek: "週間を生成",
    connectionSchedulePairsAutoUnavailable: "安全に生成するには、乗換地点での実際の到着・出発時刻と最大待ち時間が必要です。各組み合わせを明示的に選択してください。",
    connectionSchedulePairsEmpty: "運行時刻の組み合わせを1つ以上追加してください。",
    connectionSchedulePairsRequired: "運行時刻の組み合わせが1つ以上必要です。",
    connectionSchedulePairsIncomplete: "各行で両方の運行時刻を選択してください。",
    connectionSchedulePairsDuplicate: "この運行時刻の組み合わせは既に存在します。",
    connectionSchedulePairsGenerated: "一意に決定できる組み合わせを{count}件生成しました。",
    connectionSchedulePairsGeneratedWithAmbiguous: "{count}件の組み合わせを生成しました。{ambiguous}件の日付・週区分グループには複数の運行時刻があるため、明示的な選択が必要です。",
    connectionScheduleEveryWeek: "毎週",
    connectionScheduleOddWeeks: "奇数週",
    connectionScheduleEvenWeeks: "偶数週",
    connectionFamilyScheduleCount: "{count}件の運行時刻",
    connectionTransferStation: "Statie de transfer",
    connectionFromStation: "De la",
    connectionToStation: "Pana la",
    connectionSaved: "Conexiune salvata",
    connectionCreated: "Conexiune creata",
    connectionBsBsImported: "Conexiune BS+BS importata",
    connectionStatusUpdated: "Status actualizat",
    connectionFamilyActivationSuccess: "{total}件の運行時刻をすべて有効にしました。",
    connectionFamilyActivationNone: "運行時刻を有効にできませんでした（0/{total}）。無効な運行時刻を確認してください。",
    connectionFamilyActivationPartial: "{total}件中{activated}件の運行時刻を有効にしました。ファミリーは一部有効のままです。",
    connectionFamilyDeactivationSuccess: "{total}件の運行時刻をすべて無効にしました。",
    connectionFamilyDeactivationIncomplete: "一部の運行時刻を無効にできませんでした（{deactivated}/{total}）。更新して再試行してください。",
    connectionSaveError: "Eroare la salvare",
    connectionRoutesLoadError: "Eroare la incarcarea rutelor",
    connectionScheduleLoadError: "Eroare la incarcarea orarului",
    connectionStationsLoadError: "Eroare la incarcarea statiilor",
    connectionSegment1ValidPairs: "Segment 1 perechi valide:",
    connectionSegment2ValidPairs: "Segment 2 perechi valide:",
    connectionTotalCombinations: "Total combinatii:",
    connectionNoCombinationsEdit: "Nu exista combinatii vandabile pentru configuratia curenta.",
    connectionNoCombinationsCreate: "Nu exista combinatii vandabile pentru ancorele selectate.",
    connectionFewCombinationsEdit: "Numar mic de combinatii generate. Verificati segmentele ancora.",
    connectionFewCombinationsCreate: "Numar mic de combinatii generate. Verificati preturile si opririle.",
    connectionCombinationsUpdated: "Combinatiile au fost actualizate cu succes.",
    connectionCombinationsGenerated: "Combinatiile au fost generate cu succes.",
    connectionErrorSessionExpired: "Sesiune expirata. Va rugam sa va autentificati din nou.",
    connectionErrorNoPermission: "Nu aveti permisiunea pentru aceasta actiune.",
    connectionErrorNotFound: "Resursa nu a fost gasita sau modulul nu este disponibil.",
    connectionErrorNoSegment1Pairs: "Segmentul 1 nu are perechi valide cu pret general. Ajustati ancora de plecare sau ruta.",
    connectionErrorNoSegment2Pairs: "Segmentul 2 nu are perechi valide cu pret general. Ajustati ancora de transfer sau destinatia.",
    connectionErrorNoCombinations: "Nu exista combinatii vandabile intre cele doua ancore. Verificati preturile si opririle.",
    connectionErrorInvalidTransferStop: "Statia de transfer selectata nu este valida pentru ruta segmentului.",
    connectionErrorInvalidTransferTimeSource: "Nu se poate calcula timpul de transfer — datele de orar lipsesc sau sunt incomplete.",
    connectionErrorTransferContinuity: "Orasul de transfer trebuie sa fie acelasi intre cele doua segmente.",
    connectionErrorFamilyMemberInUse: "予約や他の依存関係があるため、この運行時刻は削除または置換できません。",
    connectionErrorUnexpected: "Eroare neasteptata. Incercati din nou.",
    connectionBusIdLabel: "Bus",
    connectionRouteStatusLabel: "Status Rută",
    connectionRouteActive: "Activă",
    connectionRouteInactive: "Inactivă",
    connectionConnOnlyLabel: "Doar Conexiuni",
    connectionConnOnlyYes: "Doar con.",
    connectionTimeIdLabel: "ID Orar",
    connectionFromIdLabel: "De la",
    connectionToIdLabel: "Pana la",
    connectionTabSegments: "セグメント",
    connectionTabSettings: "設定",
    connectionTabRouteInfo: "ルート情報",
    connectionPlatformsTab: "プラットフォーム",
    connectionPlatformsHelper: "この接続を販売する商業プラットフォームを選択してください。選択を空にすると、すべてのプラットフォームでこの接続は非表示になります。",
    connectionPlatformsSaved: "接続プラットフォームを保存しました。",
    connectionPlatformsSaveError: "接続プラットフォームを保存できませんでした。",
    connectionDiscard: "変更を破棄",
    connectionPaymentMethodsTab: "支払い方法",
    connectionPlatformPaymentIndependentHint: "接続の支払い方法は商業プラットフォームごとに設定され、セグメントの路線とは独立しています。",
    connectionPaymentMethodSaveError: "支払い方法の保存エラー",
    connectionDiagArrival: "Sosire",
    connectionHandoffTitle: "Detalii transfer",
    connectionDropoff: "Coborâre Segment 1",
    connectionPickup: "Îmbarcare Segment 2",
    connectionWaitingTime: "Timp de așteptare",
    connectionTransferTime: "Timp de conexiune",
    platformPaymentTableTitle: "Payment methods per platform",
    platformPaymentTableDescription: "Configure how passengers pay on each commercial platform.",
    platformPaymentColumnPlatform: "Platform",
    platformPaymentColumnCash: "Cash",
    platformPaymentCashAddAll: "Add all",
    platformPaymentApplyToAll: "Apply to all platforms",
    platformPaymentColumnOnline: "Online payment",
    platformPaymentColumnStatus: "Status",
    platformPaymentStatusActive: "Active",
    platformPaymentStatusLocked: "Not visible · locked",
    platformPaymentStatusInvalid: "Invalid",
    platformPaymentEmpty: "No commercial platforms attached. Add platforms in the Platforms tab to configure payments.",
    platformPaymentDiscard: "Discard",
    platformPaymentSave: "Save changes",
    platformPaymentSaveSuccess: "Payment configuration saved",
    platformPaymentSaveError: "Error saving payment configuration",
    platformPaymentSaveValidation: "Please review the highlighted rows",
    platformPaymentErrorVisibleMissingMethod: "Choose Cash or an Online method.",
    platformPaymentErrorGeneric: "Invalid configuration.",
    platformPaymentOnlineNone: "None",
    platformPaymentOnlineMaib: "MAIB",
    platformPaymentOnlineNetopia: "Netopia",
    platformPaymentOnlineNetopiaConfigOnly: "Netopia (configuration only)",
    platformPaymentOnlineCarrierManaged: "Carrier-managed online",
    platformPaymentUnknownPlatform: "Unknown platform",
    platformPaymentReason_visible_platform_missing_method: "Choose Cash or an Online method.",
    platformPaymentReason_visible_platform_missing_assignment: "Assignment missing for this visible platform.",
    platformPaymentReason_duplicate_platform_assignment: "Duplicate platform assignment.",
    platformPaymentReason_unknown_hosted_method: "Online method not supported.",
    platformPaymentReason_method_not_hosted_family: "Online method must be hosted.",
    platformPaymentReason_hosted_method_not_in_registry: "Online method is not registered.",
    platformPaymentReason_registry_method_not_hosted: "Online method family mismatch.",
    platformPaymentReason_bus_system_not_hosted: "BusSystem cannot be used as hosted online method.",
    platformPaymentReason_cash_not_hosted_method: "Cash cannot be used as online method.",
    platformPaymentReason_inactive_non_visible: "Platform is no longer visible.",
    platformPaymentReason_platform_required: "Platform is required.",
    platformPaymentManagedByBusSystem: "Managed by BusSystem",
    platformPaymentCashOn: "On",
    platformPaymentCashOff: "Off",
  },
  fr: {
    dashboard: "Générateur de mise",
    layoutBuilder: "En page",
    craft: "Fabriqué",
    pages: "Pages",
    profile: "Profil",
    profileOverview: "Aperçu",
    projects: "Projets",
    campaigns: "Campagnes",
    documents: "Documents",
    connections: "Connexions",
    wizards: "Sorciers",
    horizontal: "Horizontal",
    vertical: "Verticale",
    account: "Compte",
    accountOverview: "Aperçu",
    settings: "Paramètres",
    authentication: "Authentification",
    basicFlow: "Flux de base",
    signIn: "SS'identifier",
    signUp: "Inscrivez-vous",
    passwordReset: "Réinitialisation du mot de passe",
    multiStepSignUp: "S'Inscrire Multi-Étapes",
    error404: "Erreur 404",
    error500: "Erreur 500",
    apps: "Applications",
    chat: "Discuter",
    widgets: "Widgets",
    widgetsLists: "Listes",
    widgetsStatistics: "Statistiques",
    widgetsCharts: "Graphiques",
    widgetsMixed: "Mixte",
    widgetsTables: "Les tables",
    widgetsFeeds: "Flux",
    changelog: "Journal des modifications",
    docsAndComponents: "Documents & composants",
    megaMenu: "Méga Menu",
    exampleLink: "Exemple de lien",
    modals: "Modals",
    general: "Général",
    inviteFriends: "Inviter Des Amis",
    viewUsers: "Voir Les Utilisateurs",
    upgradePlan: "Plan De Mise À Niveau",
    shareAndEarn: "Partager Et Gagner",
    forms: "Formes",
    newTarget: "Nouvelle Cible",
    newCard: "Nouvelle Carte",
    newAddress: "Nouvelle Adresse",
    createAPIKey: "Créer Une Touche Api",
    twoFactorAuth: "Deux Facteurs D'Authentification",
    createApp: "Créer Une Application",
    createAccount: "Créer Un Compte",
    activity: "Activité",
    documentation: "Documentation",
    components: "Composants",
    resources: "Ressources",
    customers: "Les Clients",
    gettingStarted: "Commencer",
    customersListing: "Liste Des Clients",
    customerDetails: "Détails Des Clients",
    calendarApp: "Calendrier",
    subscriptions: "Abonnements",
    getStarted: "Commencer",
    subscriptionList: "Liste D'Abonnement",
    addSubscription: "Ajouter Un Abonnement",
    viewSubscription: "Voir L'Abonnement",
    connectionRouteInfoTitle: "Informatii ruta",
    connectionRouteInfoRouteAndPricesTab: "Traseu & Prețuri",
    connectionRouteInfoRouteTab: "Traseu & Adrese",
    connectionRouteInfoLocality: "Localitate",
    connectionRouteInfoAddress: "Adresa",
    connectionRouteInfoToAddress: "La adresa",
    connectionRouteInfoTransfer: "Transfer",
    connectionRouteInfoPriceCategoriesTab: "Categorii de preturi",
    connectionRouteInfoPriceCategory: "Categorie de pret",
    connectionRouteInfoPricesTab: "Prețuri",
    connectionRouteInfoPrice: "Pret",
    connectionRouteInfoArrival: "Localitatea de sosire",
    connectionRouteInfoTotal: "Total",
    connectionRouteInfoFareBreakdown: "Defalcare preț",
    connectionRouteInfoFareHint: "Alege punctul de îmbarcare și cel de coborâre pentru a vedea tariful exact al acelei călătorii.",
    connectionRouteInfoSelectPrompt: "Selectează plecarea și sosirea pentru a vedea prețul.",
    connectionRouteInfoConvertedNote: "Segmentele sunt normalizate și convertite în moneda conexiunii.",
    connectionRouteInfoDeparture: "Localitatea de plecare",
    connectionRouteInfoSegment: "Segment",
    connectionRouteInfoUnavailable: "Date indisponibile",
    connectionRouteInfoNoRoute: "Date indisponibile — segmentele nu au rute asociate.",
    connectionRouteInfoNoPriceData: "Date indisponibile — nu exista puncte de traseu sau categorii de pret.",
    connectionRouteInfoTbd: "TBD",
    connectionRouteInfoYes: "Da",
    connectionRouteInfoRouteLoadError: "Eroare la incarcarea datelor de ruta. Reincercati mai tarziu.",
    connectionRouteInfoPricesLoadError: "Eroare la incarcarea preturilor. Reincercati mai tarziu.",
    connectionRouteInfoAvailableIn: "Disponibil in",
    connectionRouteInfoSegmentLoadError: "Eroare la incarcarea datelor pentru acest segment.",
    connectionRouteInfoTransferIndicator: "Transfer",
    connectionRouteInfoDay1: "Lun",
    connectionRouteInfoDay2: "Mar",
    connectionRouteInfoDay3: "Mie",
    connectionRouteInfoDay4: "Joi",
    connectionRouteInfoDay5: "Vin",
    connectionRouteInfoDay6: "Sam",
    connectionRouteInfoDay7: "Dum",
    connectionFinalPrice: "Pret final conexiune",
    connectionAuthoritativeTotal: "Total destinatie configurata",
    connectionTransferMode: "Mod transfer",
    connectionTransferModeOrganized: "Organizat",
    connectionTransferModeUnorganized: "Neorganizat",
    connectionTransferInstructions: "Instructiuni de transfer",
    connectionTransferInstructionsRo: "Romana (RO)",
    connectionTransferInstructionsRu: "Rusa (RU)",
    connectionTransferInstructionsEn: "Engleza (EN)",
    connectionTransferInstructionsUk: "Ucraineana (UK)",
    connectionDepartureOverride: "Suprascriere instructiuni transfer plecare",
    connectionDepartureOverrideLoad: "Incarca suprascriere",
    connectionDepartureOverrideSave: "Salveaza suprascriere",
    connectionDepartureOverrideWarning: "Modificarile afecteaza TOATE rezervarile din aceasta plecare, nu doar cea curenta.",
    connectionDepartureOverrideActive: "Suprascriere activa — se vor folosi instructiunile specifice plecarii",
    connectionDepartureOverrideNone: "Fara suprascriere — se folosesc valorile implicite ale conexiunii",
    connectionTransferInstructionsPlaceholderRo: "Instructiuni transfer (RO)",
    connectionTransferInstructionsPlaceholderRu: "Instructiuni transfer (RU)",
    connectionTransferInstructionsPlaceholderEn: "Instructiuni transfer (EN)",
    connectionTransferInstructionsPlaceholderUk: "Instructiuni transfer (UK)",
    connectionCreateTitle: "Creaza conexiune",
    connectionEditTitle: "Conexiune",
    connectionEditTitleWithId: "Conexiune #{id}",
    connectionEditTitleWithIdAndRoute: "Conexiune #{id} — {route}",
    connectionSave: "Salveaza",
    connectionImportBsBs: "Importa BS+BS",
    connectionCreate: "Creaza",
    connectionType: "Tip conexiune",
    connectionTypeLocalLocal: "Local + Local",
    connectionTypeBsBsImport: "BS + BS (import)",
    connectionTypeBsBsBadge: "BS + BS (importat)",
    connectionTypeLocalLocalBadge: "Local + Local",
    connectionSegment1: "Segment 1",
    connectionSegment2: "Segment 2",
    connectionSegmentDepartureToTransfer: "Plecare → Punct de transfer",
    connectionSegmentTransferToDestination: "Punct de transfer → Destinație",
    connectionTransfer: "Transfer",
    connectionImportedSegments: "Segmente importate",
    connectionImportedReadonly: "Conexiune importata — campurile structurale sunt read-only",
    connectionSegmentsReadonly: "Segmente (read-only)",
    connectionPosition: "Pozitie",
    connectionSegment1Helper: "Segmentul 1 defineste ancora de plecare pana la orasul de transfer. Backend-ul extinde automat toate combinatiile eligibile.",
    connectionSegment2Helper: "Segmentul 2 defineste ancora de la orasul de transfer pana la destinatie. Combinatiile finale sunt generate automat de backend.",
    connectionSegment1HelperEdit: "Ancora segment 1: punct de plecare pana la transfer.",
    connectionSegment2HelperEdit: "Ancora segment 2: transfer pana la destinatie.",
    connectionAnchorsAlert: "Segmentele selectate sunt ancore. Backend-ul extinde automat combinatiile eligibile intre cele doua segmente.",
    connectionBsBsImportInfo: "Importul BS+BS foloseste endpoint-ul dedicat /connections/import-bs.",
    connectionSettings: "Setări conexiune",
    connectionStatus: "Status",
    connectionStatusDraft: "Draft",
    connectionStatusActive: "Activ",
    connectionStatusInactive: "Inactiv",
    connectionTransferTimeMinutes: "Timp transfer (minute)",
    connectionFeePerPassenger: "Taxa per pasager",
    connectionFeeCurrency: "Valuta taxa",
    connectionFeeCurrencyPlaceholder: "Valuta",
    connectionCurrency: "Valuta conexiunii",
    connectionCurrencyPlaceholder: "Valuta",
    connectionCurrencyHelper: "Valuta totalului conexiunii — separată de valuta taxei.",
    connectionRefundPolicyLabel: "Politica de refund",
    connectionRefundPolicyPlaceholder: "Selecteaza o politica de refund",
    connectionRefundPolicyHelper: "Refundurile la anulare folosesc politica selectata cand conexiunea este vanduta.",
    connectionRefundPolicyDisabledBs: "Politicile de refund nu pot fi atasate conexiunilor importate (BusSystem).",
    connectionRefundPolicySaved: "Politica de refund a fost actualizata.",
    connectionRefundPolicySaveError: "Nu am putut salva politica de refund.",
    connectionFrom: "De la",
    connectionTo: "Pana la",
    connectionCompanyNum: "Companie {num}",
    connectionRoute: "Ruta",
    connectionOpenRoute: "Deschide ruta",
    connectionTime: "Ora",
    connectionStatusPartial: "Partiellement active",
    connectionManualStatus: "Statut manuel",
    connectionManualStatusHelper: "Cet interrupteur contrôle l'intention de l'opérateur. La publication sur les plateformes est affichée séparément.",
    connectionPublicationStatus: "Publication sur les plateformes",
    connectionPublicationPublished: "Publiée",
    connectionPublicationPendingRebuild: "Reconstruction en attente",
    connectionPublicationBlocked: "Bloquée",
    connectionPublicationRebuildFailed: "Échec de la reconstruction",
    connectionPublicationUnpublished: "Non publiée",
    connectionPublicationPartial: "Partiellement publiée",
    connectionRebuildStatus: "Dernière reconstruction",
    connectionRebuildSucceeded: "Réussie",
    connectionRebuildUnpublished: "Aucun résultat publié",
    connectionRebuildPartial: "Résultats de reconstruction mixtes",
    connectionPublishedGenerationAt: "Génération publiée : {date}",
    connectionRebuildCheckedAt: "Reconstruction vérifiée : {date}",
    connectionPublicationReason: "Motif : {reason}",
    connectionPublicationCheckedAt: "Vérifié : {date}",
    connectionPublicationWarningTitle: "Statut de publication : {status}",
    connectionRebuildWarningTitle: "Dernière reconstruction : {status}",
    connectionPublicationPartialDescription: "Certains horaires ne sont actuellement pas affichés sur les plateformes. Vérifiez chaque horaire ci-dessous.",
    connectionPublicationUnpublishedDescription: "Aucun horaire de cette connexion n'est actuellement affiché sur les plateformes.",
    connectionPublicationBlockedDescription: "La connexion ne peut actuellement pas être affichée sur les plateformes. Corrigez le problème d'itinéraire indiqué ci-dessous.",
    connectionPublicationRebuildFailedDescription: "La dernière reconstruction de publication a échoué. Le statut manuel de l'opérateur n'a pas été modifié.",
    connectionRebuildFailedLiveDescription: "La dernière reconstruction a échoué, mais la génération publiée précédente reste affichée sur les plateformes.",
    connectionRebuildFailedNoLiveDescription: "La dernière reconstruction a échoué et aucune offre n'est actuellement affichée sur les plateformes.",
    connectionRebuildFailedPartialLiveDescription: "La dernière reconstruction comporte des échecs. Seuls les horaires marqués comme publiés restent affichés.",
    connectionRebuildFailedUnknownLiveDescription: "La dernière reconstruction a échoué. Cette ancienne réponse ne confirme pas si une génération précédente reste affichée.",
    connectionPublicationReasonManualInactive: "Le statut manuel est inactif.",
    connectionPublicationReasonParentRouteMissing: "Un itinéraire parent n'existe plus.",
    connectionPublicationReasonParentRouteInactive: "Un itinéraire parent est inactif.",
    connectionPublicationReasonAnchorStopMissing: "Un arrêt de la connexion n'existe plus.",
    connectionPublicationReasonAnchorStopRouteMismatch: "Un arrêt de la connexion n'appartient plus à l'itinéraire sélectionné.",
    connectionPublicationReasonAnchorStopOrderInvalid: "Les arrêts de la connexion ne sont plus dans un ordre valide.",
    connectionPublicationReasonScheduleMissing: "Un horaire sélectionné n'existe plus.",
    connectionPublicationReasonAnchorTimeMissing: "L'heure d'arrivée ou de départ manque à un arrêt de la connexion.",
    connectionPublicationReasonTransferContinuity: "Les deux segments ne se rejoignent plus au même point de correspondance.",
    connectionPublicationReasonTransferTimeSource: "Le temps de correspondance ne peut pas être calculé à partir de l'horaire actuel.",
    connectionPublicationReasonNoSegment1Pairs: "Le segment 1 n'a aucune paire d'itinéraires vendable.",
    connectionPublicationReasonNoSegment2Pairs: "Le segment 2 n'a aucune paire d'itinéraires vendable.",
    connectionPublicationReasonNoCombinations: "Les horaires sélectionnés n'ont aucune combinaison de connexion vendable.",
    connectionPublicationReasonTemporaryFailure: "Une erreur temporaire a empêché la vérification de publication. Elle sera relancée.",
    connectionPublicationReasonBuildFailure: "La reconstruction de la publication sur les plateformes a échoué.",
    connectionPublicationReasonInvalidSegments: "La structure des segments de la connexion est invalide.",
    connectionSchedulePairsTitle: "Paires d'horaires",
    connectionSchedulePairsHelper: "Sélectionnez l'horaire exact de chaque segment. La première paire sert d'ancrage pour l'aperçu de l'itinéraire.",
    connectionSchedulePairsSegment1: "Horaire du segment 1",
    connectionSchedulePairsSegment2: "Horaire du segment 2",
    connectionSchedulePairsAdd: "Ajouter une paire",
    connectionSchedulePairsRemove: "Supprimer la paire",
    connectionSchedulePairsRemoveExistingConfirm: "Cet horaire enregistré sera supprimé lors de l'enregistrement. L'opération peut être bloquée s'il existe des réservations ou d'autres dépendances. Continuer ?",
    connectionSchedulePairStatus: "Statut",
    connectionSchedulePairStatusNew: "Nouvelle",
    connectionConfirm: "Confirmer",
    connectionCancel: "Annuler",
    connectionSchedulePairsGenerateWeek: "Générer la semaine",
    connectionSchedulePairsAutoUnavailable: "La génération sûre nécessite les heures réelles d'arrivée et de départ au point de correspondance ainsi qu'une limite d'attente maximale. Sélectionnez chaque paire explicitement.",
    connectionSchedulePairsEmpty: "Ajoutez au moins une paire d'horaires.",
    connectionSchedulePairsRequired: "Au moins une paire d'horaires est requise.",
    connectionSchedulePairsIncomplete: "Complétez les deux horaires de chaque ligne.",
    connectionSchedulePairsDuplicate: "Cette paire d'horaires existe déjà.",
    connectionSchedulePairsGenerated: "{count} paires non ambiguës ont été générées.",
    connectionSchedulePairsGeneratedWithAmbiguous: "{count} paires ont été générées. {ambiguous} groupes jour/parité contiennent plusieurs horaires et nécessitent une sélection explicite.",
    connectionScheduleEveryWeek: "chaque semaine",
    connectionScheduleOddWeeks: "semaines impaires",
    connectionScheduleEvenWeeks: "semaines paires",
    connectionFamilyScheduleCount: "{count} horaires",
    connectionTransferStation: "Statie de transfer",
    connectionFromStation: "De la",
    connectionToStation: "Pana la",
    connectionSaved: "Conexiune salvata",
    connectionCreated: "Conexiune creata",
    connectionBsBsImported: "Conexiune BS+BS importata",
    connectionStatusUpdated: "Status actualizat",
    connectionFamilyActivationSuccess: "Les {total} horaires ont été activés.",
    connectionFamilyActivationNone: "Aucun horaire n’a pu être activé (0/{total}). Vérifiez les horaires non valides.",
    connectionFamilyActivationPartial: "{activated} horaires sur {total} ont été activés. La famille reste partiellement active.",
    connectionFamilyDeactivationSuccess: "Les {total} horaires ont été désactivés.",
    connectionFamilyDeactivationIncomplete: "Tous les horaires n’ont pas été désactivés ({deactivated}/{total}). Actualisez puis réessayez.",
    connectionSaveError: "Eroare la salvare",
    connectionRoutesLoadError: "Eroare la incarcarea rutelor",
    connectionScheduleLoadError: "Eroare la incarcarea orarului",
    connectionStationsLoadError: "Eroare la incarcarea statiilor",
    connectionSegment1ValidPairs: "Segment 1 perechi valide:",
    connectionSegment2ValidPairs: "Segment 2 perechi valide:",
    connectionTotalCombinations: "Total combinatii:",
    connectionNoCombinationsEdit: "Nu exista combinatii vandabile pentru configuratia curenta.",
    connectionNoCombinationsCreate: "Nu exista combinatii vandabile pentru ancorele selectate.",
    connectionFewCombinationsEdit: "Numar mic de combinatii generate. Verificati segmentele ancora.",
    connectionFewCombinationsCreate: "Numar mic de combinatii generate. Verificati preturile si opririle.",
    connectionCombinationsUpdated: "Combinatiile au fost actualizate cu succes.",
    connectionCombinationsGenerated: "Combinatiile au fost generate cu succes.",
    connectionErrorSessionExpired: "Sesiune expirata. Va rugam sa va autentificati din nou.",
    connectionErrorNoPermission: "Nu aveti permisiunea pentru aceasta actiune.",
    connectionErrorNotFound: "Resursa nu a fost gasita sau modulul nu este disponibil.",
    connectionErrorNoSegment1Pairs: "Segmentul 1 nu are perechi valide cu pret general. Ajustati ancora de plecare sau ruta.",
    connectionErrorNoSegment2Pairs: "Segmentul 2 nu are perechi valide cu pret general. Ajustati ancora de transfer sau destinatia.",
    connectionErrorNoCombinations: "Nu exista combinatii vandabile intre cele doua ancore. Verificati preturile si opririle.",
    connectionErrorInvalidTransferStop: "Statia de transfer selectata nu este valida pentru ruta segmentului.",
    connectionErrorInvalidTransferTimeSource: "Nu se poate calcula timpul de transfer — datele de orar lipsesc sau sunt incomplete.",
    connectionErrorTransferContinuity: "Orasul de transfer trebuie sa fie acelasi intre cele doua segmente.",
    connectionErrorFamilyMemberInUse: "Cet horaire ne peut pas être supprimé ni remplacé, car il comporte des réservations ou d'autres dépendances.",
    connectionErrorUnexpected: "Eroare neasteptata. Incercati din nou.",
    connectionBusIdLabel: "Bus",
    connectionRouteStatusLabel: "Status Rută",
    connectionRouteActive: "Activă",
    connectionRouteInactive: "Inactivă",
    connectionConnOnlyLabel: "Doar Conexiuni",
    connectionConnOnlyYes: "Doar con.",
    connectionTimeIdLabel: "ID Orar",
    connectionFromIdLabel: "De la",
    connectionToIdLabel: "Pana la",
    connectionTabSegments: "Segments",
    connectionTabSettings: "Paramètres",
    connectionTabRouteInfo: "Info Itinéraire",
    connectionPlatformsTab: "Plateformes",
    connectionPlatformsHelper: "Choisissez les plateformes commerciales sur lesquelles cette connexion est vendue. Une sélection vide masque la connexion sur toutes les plateformes.",
    connectionPlatformsSaved: "Plateformes de la connexion enregistrées.",
    connectionPlatformsSaveError: "Impossible d'enregistrer les plateformes de la connexion.",
    connectionDiscard: "Annuler les modifications",
    connectionPaymentMethodsTab: "Méthodes de paiement",
    connectionPlatformPaymentIndependentHint: "Les méthodes de paiement de la connexion sont configurées par plateforme commerciale et sont indépendantes des trajets des segments.",
    connectionPaymentMethodSaveError: "Erreur lors de l'enregistrement du mode de paiement",
    connectionDiagArrival: "Sosire",
    connectionHandoffTitle: "Detalii transfer",
    connectionDropoff: "Coborâre Segment 1",
    connectionPickup: "Îmbarcare Segment 2",
    connectionWaitingTime: "Timp de așteptare",
    connectionTransferTime: "Timp de conexiune",
    platformPaymentTableTitle: "Payment methods per platform",
    platformPaymentTableDescription: "Configure how passengers pay on each commercial platform.",
    platformPaymentColumnPlatform: "Platform",
    platformPaymentColumnCash: "Cash",
    platformPaymentCashAddAll: "Add all",
    platformPaymentApplyToAll: "Apply to all platforms",
    platformPaymentColumnOnline: "Online payment",
    platformPaymentColumnStatus: "Status",
    platformPaymentStatusActive: "Active",
    platformPaymentStatusLocked: "Not visible · locked",
    platformPaymentStatusInvalid: "Invalid",
    platformPaymentEmpty: "No commercial platforms attached. Add platforms in the Platforms tab to configure payments.",
    platformPaymentDiscard: "Discard",
    platformPaymentSave: "Save changes",
    platformPaymentSaveSuccess: "Payment configuration saved",
    platformPaymentSaveError: "Error saving payment configuration",
    platformPaymentSaveValidation: "Please review the highlighted rows",
    platformPaymentErrorVisibleMissingMethod: "Choose Cash or an Online method.",
    platformPaymentErrorGeneric: "Invalid configuration.",
    platformPaymentOnlineNone: "None",
    platformPaymentOnlineMaib: "MAIB",
    platformPaymentOnlineNetopia: "Netopia",
    platformPaymentOnlineNetopiaConfigOnly: "Netopia (configuration only)",
    platformPaymentOnlineCarrierManaged: "Carrier-managed online",
    platformPaymentUnknownPlatform: "Unknown platform",
    platformPaymentReason_visible_platform_missing_method: "Choose Cash or an Online method.",
    platformPaymentReason_visible_platform_missing_assignment: "Assignment missing for this visible platform.",
    platformPaymentReason_duplicate_platform_assignment: "Duplicate platform assignment.",
    platformPaymentReason_unknown_hosted_method: "Online method not supported.",
    platformPaymentReason_method_not_hosted_family: "Online method must be hosted.",
    platformPaymentReason_hosted_method_not_in_registry: "Online method is not registered.",
    platformPaymentReason_registry_method_not_hosted: "Online method family mismatch.",
    platformPaymentReason_bus_system_not_hosted: "BusSystem cannot be used as hosted online method.",
    platformPaymentReason_cash_not_hosted_method: "Cash cannot be used as online method.",
    platformPaymentReason_inactive_non_visible: "Platform is no longer visible.",
    platformPaymentReason_platform_required: "Platform is required.",
    platformPaymentManagedByBusSystem: "Managed by BusSystem",
    platformPaymentCashOn: "On",
    platformPaymentCashOff: "Off",
  },
};

// The whole Partner admin is in Romanian and there is no language selector
// yet, so the namespaced catalogs (i7a, payment claim, reports, …) render in
// `ro`. The legacy template keys only exist in en/es/de/ja/fr: they keep
// resolving to `en` through the fallback, silently.
const i18n = createI18n({
  legacy: false,
  locale: "ro",
  fallbackLocale: "en",
  missingWarn: false,
  fallbackWarn: false,
  globalInjection: true,
  // Only the `i7a.*` namespace is provided in ro/ru/en; legacy keys unchanged.
  messages: withI7aMessages(messages),
});

registerI7aI18n(i18n);
// I7-B keeps its own bounded catalog and only follows this instance's locale.
registerI7bI18n(i18n);
// Promotions keep their own bounded catalog and only follow this locale.
registerPromotionsI18n(i18n);
// X13 message templates: own bounded catalog, follows this locale only.
registerMessageTemplatesI18n(i18n);

export default i18n;
